import { DESKTOP_NATIVE_ENGLISH } from "./desktop-native"
import { accountingNavigationEn } from "./accounting-navigation"
import { accountingSetupEn } from "./accounting-setup"
import { financialOverviewEn } from "./financial-overview"
import { chatDockEn } from "./chat-dock"
import { bookImportsEn, bookImportErrorsEn, trialBalanceReviewEn } from "./book-imports"
import { agentProposalsEn } from "./agent-proposals"
import { dashboardEn } from "./dashboard"
import { knowledgeGuidanceEn } from "./knowledge-guidance"
import { accountingOverviewEn } from "./accounting-overview"
import { booksEn, journalLifecycleEn, bulkJournalEn } from "./books"
import { accountingPeriodsEn } from "./accounting-periods"
import { billingBooksEn } from "./billing-books"
import { paymentsBooksEn } from "./payments-books"
import { financialBooksEn, financialReadErrorsEn, trialBalanceGroupingEn, financialDownloadEn } from "./financial-books"
import { vatBooksEn } from "./vat-books"
import { vatDeclarationsEn } from "./vat-declarations"
import { personnelBooksEn } from "./personnel-books"
import { advancesBooksEn } from "./advances-books"
import { supplierAdvancesBooksEn } from "./supplier-advances-books"
import { prepaymentInvoicesEn } from "./prepayment-invoices-books"
import { invoiceAttachmentsEn } from "./invoice-attachments"
import { bookCatalogEn } from "./book-catalog"
import { bookDimensionsEn } from "./book-dimensions"
import { fixedAssetsEn } from "./fixed-assets-books"
import { assetWorkspaceEn } from "./asset-workspace"
import { reportLineMappingsEn } from "./report-line-mappings"
import { reportWorkspaceEn } from "./report-workspace"
import { workflowActivityEn } from "./workflow-activity"

export const dict = {
  ...workflowActivityEn,
  ...reportWorkspaceEn,
  ...accountingNavigationEn,
  ...accountingSetupEn,
  ...financialOverviewEn,
  ...chatDockEn,
  ...bookImportsEn,
  ...bookImportErrorsEn,
  ...trialBalanceReviewEn,
  ...agentProposalsEn,
  ...accountingOverviewEn,
  ...booksEn,
  ...journalLifecycleEn,
  ...bulkJournalEn,
  ...accountingPeriodsEn,
  ...billingBooksEn,
  ...paymentsBooksEn,
  ...financialBooksEn,
  ...financialReadErrorsEn,
  ...trialBalanceGroupingEn,
  ...financialDownloadEn,
  ...vatBooksEn,
  ...vatDeclarationsEn,
  ...personnelBooksEn,
  ...advancesBooksEn,
  ...supplierAdvancesBooksEn,
  ...prepaymentInvoicesEn,
  ...invoiceAttachmentsEn,
  ...bookCatalogEn,
  ...bookDimensionsEn,
  ...fixedAssetsEn,
  ...assetWorkspaceEn,
  ...reportLineMappingsEn,
  ...dashboardEn,
  ...knowledgeGuidanceEn,
  "cowork.files.fields.documentFields": "Document fields",
  "cowork.files.fields.filename": "Filename",
  "cowork.files.fields.contentType": "Content type",
  "cowork.files.fields.pages": "Pages",
  "cowork.files.fields.sourceText": "Source text",
  "cowork.files.fields.unitPrice": "Unit price",
  "cowork.files.fields.sellerRegistrationNumber": "Seller registration number",
  "cowork.files.fields.buyerRegistrationNumber": "Buyer registration number",
  "cowork.enterprise.files.filters.fileType": "File type",
  "cowork.enterprise.files.filters.payroll": "Payroll",
  "cowork.enterprise.files.filters.unknownType": "Unknown",
  "cowork.enterprise.files.filters.search": "Search files, sellers, invoice numbers…",
  "cowork.enterprise.files.filters.searchSellers": "Search sellers…",
  "cowork.enterprise.files.filters.notExtracted": "Not extracted yet",
  "cowork.enterprise.files.filters.unknownSeller": "Seller not identified",
  "cowork.enterprise.files.filters.extractionFailed": "Extraction failed",
  "cowork.enterprise.files.filters.clear": "Clear filters",
  "cowork.enterprise.files.filters.remove": "Remove {{label}} filter",
  "cowork.enterprise.files.filters.results": "Showing {{shown}} of {{total}}",
  "cowork.enterprise.files.filters.emptyDescription": "Try changing the search or filters.",
  "cowork.files.extraction.split": "Side by side",
  "cowork.files.extraction.previousVersion": "Previous version",
  "cowork.enterprise.workflows.reporting.configure": "Configure",
  "cowork.enterprise.workflows.reporting.edit": "Edit reporting workflow",
  "cowork.enterprise.workflows.reporting.configureRequired":
    "Configuration required. Choose input files and a report template before generating. Previous runs and reports are preserved.",
  "cowork.enterprise.workflows.reporting.configureNewRun": "Configure and generate a new run",
  "cowork.enterprise.workflows.reporting.inputSelection": "Input files",
  "cowork.enterprise.workflows.reporting.existingFiles": "Select existing project uploads",
  "cowork.enterprise.workflows.reporting.noSourceFiles":
    "No available uploads in this scope. Upload files below to continue.",
  "cowork.enterprise.workflows.reporting.filesLoadFailed":
    "Could not check available input files. Retry before generating.",
  "cowork.enterprise.workflows.reporting.missingSource":
    "Unavailable in this scope. Remove this selection and upload a replacement if needed.",
  "cowork.enterprise.workflows.reporting.inputHint":
    "Select existing files or upload new ones. Retry or remove failed uploads before continuing. Cancelling leaves uploaded files in the project.",
  "cowork.enterprise.workflows.reporting.fixedPeriod": "Fixed period: {{period}}",
  "cowork.enterprise.workflows.reporting.unassignedPeriod": "No assigned period",
  "cowork.enterprise.workflows.reporting.save": "Save configuration",
  "cowork.enterprise.workflows.reporting.saveBusy": "Saving...",
  "cowork.enterprise.workflows.reporting.saveHint":
    "Save these settings without running, or choose Generate to save and start a new run. Existing agent and approval settings are preserved.",
  "cowork.enterprise.workflows.reporting.viewReports": "View reports",
  "cowork.enterprise.workflows.reporting.progress": "Report generation progress",
  "cowork.enterprise.workflows.reporting.latestFiles":
    "Read-only input snapshot from the latest run. Selecting historical runs does not change these files.",
  "cowork.enterprise.workflows.reporting.chat.missingSession":
    "This run has no chat session. Configure and generate a new run to create one.",
  "cowork.enterprise.workflows.reporting.chat.deleted": "The chat for this run has been deleted.",
  "cowork.enterprise.workflows.reporting.chat.notOwner": "Only the person who started this run can open its chat.",
  "cowork.enterprise.workflows.reporting.chat.scopeMismatch":
    "This chat is not available in the workflow's company and project.",
  "cowork.enterprise.workflows.reporting.chat.unavailable": "You do not have access to this run's chat.",
  "cowork.enterprise.workflows.reporting.reason.inputUnavailable":
    "An input file is unavailable. Edit the configuration to select available files.",
  "cowork.enterprise.workflows.reporting.reason.runtimeUnavailable":
    "The agent service is unavailable. Try again later.",
  "cowork.enterprise.workflows.reporting.title": "Create a reporting workflow",
  "cowork.enterprise.workflows.reporting.step.name": "Name",
  "cowork.enterprise.workflows.reporting.step.files": "Upload files",
  "cowork.enterprise.workflows.reporting.step.template": "Report template",
  "cowork.enterprise.workflows.reporting.upload": "Choose files to upload",
  "cowork.enterprise.workflows.reporting.uploadHint":
    "Upload at least one file. Retry or remove failed uploads before continuing. Cancelling leaves uploaded files in the project.",
  "cowork.enterprise.workflows.reporting.upload.uploading": "Uploading...",
  "cowork.enterprise.workflows.reporting.upload.success": "Uploaded",
  "cowork.enterprise.workflows.reporting.upload.failure": "Upload failed",
  "cowork.enterprise.workflows.reporting.retry": "Retry",
  "cowork.enterprise.workflows.reporting.remove": "Remove",
  "cowork.enterprise.workflows.reporting.removeFile": "Remove {{name}} from this workflow",
  "cowork.enterprise.workflows.reporting.chooseTemplate": "Choose a report template",
  "cowork.enterprise.workflows.reporting.generateHint":
    "The workflow will be saved and run with these files and the workspace's default agent. Track progress and download results here; opening the chat is optional.",
  "cowork.enterprise.workflows.reporting.back": "Back",
  "cowork.enterprise.workflows.reporting.next": "Next",
  "cowork.enterprise.workflows.reporting.generate": "Generate",
  "cowork.enterprise.workflows.reporting.saving": "Starting...",
  "cowork.enterprise.workflows.reporting.retryStart": "Retry starting this run",
  "cowork.enterprise.workflows.reporting.saveFailed":
    "Could not save the workflow. Check that the project and uploaded files still exist, then try again.",
  "cowork.enterprise.workflows.reporting.startFailed":
    "Could not confirm that the run started. Retry this attempt without creating another workflow. If the input files were deleted, create a workflow with available files.",
  "cowork.enterprise.workflows.reporting.trialReportLimit":
    "Your trial has used all of its included reports. Contact Andmera to upgrade and keep generating reports.",
  "cowork.enterprise.workflows.reporting.renameHint":
    "Renaming keeps the saved files, report template, instructions, language, and period unchanged.",
  "cowork.enterprise.workflows.reporting.loadFailed": "Could not load this workflow.",
  "cowork.enterprise.workflows.reporting.notFound": "This workflow was not found or is no longer accessible.",
  "cowork.enterprise.workflows.reporting.generateAgain": "Generate from saved configuration",
  "cowork.enterprise.workflows.reporting.freshChat":
    "Each generation starts a fresh chat. Rerunning a selected run uses its original input snapshot, not later workflow changes.",
  "cowork.enterprise.workflows.reporting.invalidConfig":
    "The saved reporting configuration is incomplete or invalid. It has not been changed. You can still view previous runs.",
  "cowork.enterprise.workflows.reporting.history": "Run history",
  "cowork.enterprise.workflows.reporting.viewRuns": "View runs",
  "cowork.enterprise.workflows.reporting.historyFailed": "Could not load run history.",
  "cowork.enterprise.workflows.reporting.refreshFailed":
    "Could not refresh this run. The last available result is shown. Retry to resume updates.",
  "cowork.enterprise.workflows.reporting.runUnavailable":
    "This run is unavailable. Retry refreshing it or choose another run.",
  "cowork.enterprise.workflows.reporting.selectedRun": "Selected run",
  "cowork.enterprise.workflows.reporting.outcome.systemResult": "System result",
  "cowork.enterprise.workflows.reporting.outcome.validation": "Validation: {{status}}",
  "cowork.enterprise.workflows.reporting.outcome.reportCount": "Saved reports: {{count}}",
  "cowork.enterprise.workflows.reporting.validation.passed": "Passed",
  "cowork.enterprise.workflows.reporting.validation.passedWithWarnings": "Passed with warnings",
  "cowork.enterprise.workflows.reporting.validation.incomplete": "Incomplete",
  "cowork.enterprise.workflows.reporting.validation.failed": "Failed",
  "cowork.enterprise.workflows.reporting.findings.title": "Validation findings",
  "cowork.enterprise.workflows.reporting.findings.blocking": "Blocking findings",
  "cowork.enterprise.workflows.reporting.findings.incomplete": "Incomplete findings",
  "cowork.enterprise.workflows.reporting.findings.warning": "Warnings",
  "cowork.enterprise.workflows.reporting.extraction.title": "Per-file extraction status",
  "cowork.enterprise.workflows.reporting.extraction.completed": "Completed",
  "cowork.enterprise.workflows.reporting.extraction.partial": "Partial",
  "cowork.enterprise.workflows.reporting.extraction.unreadable": "Unreadable",
  "cowork.enterprise.workflows.reporting.extraction.unsupported": "Unsupported",
  "cowork.enterprise.workflows.reporting.extraction.failed": "Failed",
  "cowork.enterprise.workflows.reporting.extraction.unknown": "Not recorded",
  "cowork.timeline.activity.loadGuidance": "Loading report guidance",
  "cowork.timeline.activity.reviewInformation": "Reviewing report information",
  "cowork.timeline.activity.searchInformation": "Finding relevant information",
  "cowork.timeline.activity.processData": "Processing report data",
  "cowork.timeline.activity.prepareFiles": "Preparing report files",
  "cowork.timeline.activity.loadRun": "Loading report context",
  "cowork.timeline.activity.loadSource": "Loading source document",
  "cowork.timeline.activity.loadReportDefinition": "Loading report definition",
  "cowork.timeline.activity.loadKnowledge": "Loading company knowledge",
  "cowork.timeline.activity.checkHistory": "Checking previous report data",
  "cowork.timeline.activity.calculateMetrics": "Calculating financial metrics",
  "cowork.timeline.activity.prepareReport": "Preparing report data",
  "cowork.timeline.activity.normalizeEvidence": "Normalizing accounting evidence",
  "cowork.timeline.activity.saveReport": "Saving report",
  "cowork.enterprise.workflows.reporting.execution.title": "Execution details",
  "cowork.enterprise.workflows.reporting.execution.hint":
    "Frozen settings used for this run. Later workflow or template changes do not affect these details.",
  "cowork.enterprise.workflows.reporting.execution.template": "Report template",
  "cowork.enterprise.workflows.reporting.execution.version": "Template version",
  "cowork.enterprise.workflows.reporting.execution.reportType": "Report type",
  "cowork.enterprise.workflows.reporting.execution.jurisdiction": "Jurisdiction",
  "cowork.enterprise.workflows.reporting.execution.global": "Not jurisdiction-specific",
  "cowork.enterprise.workflows.reporting.execution.runtimeAgent": "Runtime agent",
  "cowork.enterprise.workflows.reporting.execution.catalogAgent": "Catalog runtime agent",
  "cowork.enterprise.workflows.reporting.execution.parameters": "Report parameters",
  "cowork.enterprise.workflows.reporting.execution.noParameters": "No report parameters recorded",
  "cowork.enterprise.workflows.reporting.execution.requiredSkills": "Required skills and capabilities",
  "cowork.enterprise.workflows.reporting.execution.noSkills": "No required skills recorded",
  "cowork.enterprise.workflows.reporting.rerun": "Rerun these inputs",
  "cowork.enterprise.workflows.reporting.refresh": "Refresh status",
  "cowork.enterprise.workflows.reporting.waitingOwner":
    "The agent needs more information. Open the chat to respond, then refresh the status here.",
  "cowork.enterprise.workflows.reporting.waitingOther":
    "The agent needs more information from the person who started this run.",
  "cowork.enterprise.workflows.reporting.runFailed":
    "This run failed. Check the error and input files. You can open the chat if available, or explicitly start a new run.",
  "cowork.enterprise.workflows.reporting.reviewWarning":
    "These results need review and must not be treated as approved reports. You may download them for inspection.",
  "cowork.enterprise.workflows.reporting.results": "Run results",
  "cowork.enterprise.workflows.reporting.snapshotFiles": "Input files for this run",
  "cowork.enterprise.workflows.reporting.snapshotHint":
    "Only files recorded in this run's input snapshot are shown. File IDs remain visible when a filename is unavailable.",
  "cowork.enterprise.workflows.reporting.artifacts": "Reports from this run",
  "cowork.enterprise.workflows.reporting.noArtifacts": "No downloadable reports are available for this run yet.",
  "cowork.enterprise.workflows.reporting.download": "Download",
  "cowork.enterprise.workflows.reporting.downloading": "Downloading...",
  "cowork.enterprise.workflows.reporting.downloadFailed":
    "Could not download this report. It may no longer be available. Refresh the run and try again.",
  "cowork.enterprise.workflows.reporting.chatFailed": "Could not open the chat. Please try again.",
  "cowork.enterprise.workflows.reporting.stage.starting": "Starting",
  "cowork.enterprise.workflows.reporting.stage.processing_files": "Processing files",
  "cowork.enterprise.workflows.reporting.stage.analyzing": "Analyzing data",
  "cowork.enterprise.workflows.reporting.stage.generating_report": "Generating report",
  "cowork.enterprise.workflows.reporting.stage.waiting_for_input": "Waiting for input",
  "cowork.enterprise.workflows.reporting.stage.ready": "Ready to download",
  "cowork.enterprise.workflows.reporting.stage.needs_review": "Needs review",
  "cowork.enterprise.workflows.reporting.stage.failed": "Failed",
  "cowork.enterprise.workflows.reporting.stage.unknown": "Status unknown",
  ...DESKTOP_NATIVE_ENGLISH,
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Session",
  "command.category.theme": "Theme",
  "command.category.language": "Language",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.terminal": "Terminal",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Workspace",
  "command.category.settings": "Settings",
  "command.logs.export": "Export logs",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.project.open": "Open project",
  "command.project.previous": "Previous project",
  "command.project.next": "Next project",
  "command.project.index": "Switch to project {{index}}",
  "command.provider.connect": "Connect provider",
  "command.server.switch": "Switch server",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous session",
  "command.session.next": "Next session",
  "command.session.previous.unseen": "Previous unread session",
  "command.session.next.unseen": "Next unread session",
  "command.session.archive": "Archive session",

  "command.palette": "Command palette",

  "command.theme.cycle": "Cycle theme",
  "command.theme.set": "Use theme: {{theme}}",
  "command.theme.scheme.cycle": "Cycle color scheme",
  "command.theme.scheme.set": "Use color scheme: {{scheme}}",

  "command.language.cycle": "Cycle language",
  "command.language.set": "Use language: {{language}}",

  "command.session.new": "New session",
  "command.file.open": "Open file",
  "command.tab.close": "Close tab",
  "command.tab.reopenClosed": "Reopen closed tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.terminal.toggle": "Toggle terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.terminal.new": "New terminal",
  "command.terminal.new.description": "Create a new terminal tab",
  "command.steps.toggle": "Toggle steps",
  "command.steps.toggle.description": "Show or hide steps for the current message",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.workspace.toggle": "Toggle workspaces",
  "command.workspace.toggle.description": "Enable or disable multiple workspaces in the sidebar",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the session to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new session from a previous message",
  "command.session.share": "Share session",
  "command.session.share.description": "Share this session and copy the URL to clipboard",
  "command.session.unshare": "Unshare session",
  "command.session.unshare.description": "Stop sharing this session",
  "command.session.export": "Export session",
  "command.session.export.description": "Export the full session transcript as JSON",

  "palette.search.placeholder": "Search files, commands, and sessions",
  "palette.search.placeholder.home": "Search commands and sessions",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.custom.label": "Custom OpenAI-compatible provider",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.opencode.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.opencode.tagline": "Reliable optimized models",
  "dialog.provider.opencodeGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models, including Pro and Max",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.manage.provider.toggle": "Toggle all {{provider}} models",

  "dialog.model.unpaid.freeModels.title": "Free models provided by OpenCode",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",
  "dialog.model.unpaid.viewMoreProviders": "See 70+ more providers",

  "dialog.provider.viewAll": "Show more providers",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.title.anthropicProMax": "Login with Claude Pro/Max",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.method.browser": "Browser",
  "provider.connect.method.headless": "Headless",
  "provider.connect.status.inProgress": "Authorization in progress...",
  "provider.connect.status.waiting": "Waiting for authorization...",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.opencodeZen.line1":
    "OpenCode Zen gives you access to a curated set of reliable optimized models for coding agents.",
  "provider.connect.opencodeZen.line2":
    "With a single API key you'll get access to models such as Claude, GPT, Gemini, GLM and more.",
  "provider.connect.opencodeZen.visit.prefix": "Visit ",
  "provider.connect.opencodeZen.visit.link": "opencode.ai/zen",
  "provider.connect.opencodeZen.visit.suffix": " to collect your API key.",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.unavailable": "Custom providers are unavailable on this server",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",

  "model.tag.free": "Free",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.context.label": "Context",
  "model.tooltip.inputs": "Inputs",
  "model.tooltip.model": "Model",
  "model.tooltip.provider": "Provider",
  "model.tooltip.reasoning": "Reasoning",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "...",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.clear": "Clear",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.disconnect": "Disconnect",
  "common.continue": "Continue",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.default": "Default",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command... {{example}}",
  "prompt.placeholder.normal": 'Ask anything... "{{example}}"',
  "prompt.placeholder.simple": "Ask anything...",
  "prompt.placeholder.summarizeComments": "Summarize comments…",
  "prompt.placeholder.summarizeComment": "Summarize comment…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "esc to exit",
  "session.child.promptDisabled": "Subagent sessions cannot be prompted.",
  "session.child.backToParent": "Back to main session.",

  "prompt.example.1": "Fix a TODO in the codebase",
  "prompt.example.2": "What is the tech stack of this project?",
  "prompt.example.3": "Fix broken tests",
  "prompt.example.4": "Explain how authentication works",
  "prompt.example.5": "Find and fix security vulnerabilities",
  "prompt.example.6": "Add unit tests for the user service",
  "prompt.example.7": "Refactor this function to be more readable",
  "prompt.example.8": "What does this error mean?",
  "prompt.example.9": "Help me debug this issue",
  "prompt.example.10": "Generate API documentation",
  "prompt.example.11": "Optimize database queries",
  "prompt.example.12": "Add input validation",
  "prompt.example.13": "Create a new component for...",
  "prompt.example.14": "How do I deploy this project?",
  "prompt.example.15": "Review my code for best practices",
  "prompt.example.16": "Add error handling to this function",
  "prompt.example.17": "Explain this regex pattern",
  "prompt.example.18": "Convert this to TypeScript",
  "prompt.example.19": "Add logging throughout the codebase",
  "prompt.example.20": "What dependencies are outdated?",
  "prompt.example.21": "Help me write a migration script",
  "prompt.example.22": "Implement caching for this endpoint",
  "prompt.example.23": "Add pagination to this list",
  "prompt.example.24": "Create a CLI command for...",
  "prompt.example.25": "How do environment variables work here?",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.dropzone.label": "Drop images, PDFs, or text files here",
  "prompt.dropzone.file.label": "Drop to @mention file",
  "prompt.slash.badge.custom": "custom",
  "prompt.slash.badge.skill": "skill",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "active",
  "prompt.context.includeActiveFile": "Include active file",
  "prompt.context.removeActiveFile": "Remove active file from context",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add files",
  "prompt.menu.addImagesAndFiles": "Add files and more",
  "prompt.menu.imagesAndFiles": "Images and files",
  "prompt.menu.commands": "Commands",
  "prompt.menu.context": "Context",
  "prompt.menu.shellCommand": "Shell command",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",

  "prompt.toast.pasteUnsupported.title": "Unsupported attachment",
  "prompt.toast.pasteUnsupported.description": "Only images, PDFs, or text files can be attached here.",
  "prompt.toast.attachmentDuplicate.title": "This file has already been uploaded",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve session",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "dialog.lsp.empty": "LSPs auto-detected from file types",
  "dialog.plugins.empty": "Plugins configured in opencode.json",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",
  "mcp.auth.clickToAuthenticate": "Click to authenticate",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",
  "dialog.directory.action.selectFile": "Select file",
  "dialog.directory.action.selectFolder": "Select folder",
  "dialog.directory.root": "Root",
  "dialog.directory.parent": "Parent",
  "dialog.directory.readError": "Unable to read this folder",

  "app.server.unreachable": "Could not reach {{server}}",
  "app.server.retrying": "Retrying automatically...",
  "app.server.otherServers": "Other servers",

  "dialog.server.title": "Servers",
  "dialog.server.description": "Switch which OpenCode server this app connects to.",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking...",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.username": "Username (optional)",
  "dialog.server.add.usernamePlaceholder": "username",
  "dialog.server.add.password": "Password (optional)",
  "dialog.server.add.passwordPlaceholder": "password",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.default.title": "Default server",
  "dialog.server.default.description":
    "Connect to this server on app launch instead of starting a local server. Requires restart.",
  "dialog.server.default.none": "No server selected",
  "dialog.server.default.set": "Set current server as default",
  "dialog.server.default.clear": "Clear",
  "dialog.server.action.remove": "Remove server",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.current": "Current Server",
  "dialog.server.status.default": "Default",
  "wsl.server.add": "Add WSL server",
  "wsl.server.addShort": "Add WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL server",
  "wsl.server.retryStart": "Retry start",
  "wsl.server.updating": "Updating...",
  "wsl.onboarding.step.distro": "Choose distro",
  "wsl.onboarding.step.opencode": "OpenCode",
  "wsl.onboarding.checkingRuntime": "Checking WSL...",
  "wsl.onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "wsl.onboarding.ready": "WSL is ready.",
  "wsl.onboarding.required": "WSL is required to continue.",
  "wsl.onboarding.checkingDistros": "Checking distros...",
  "wsl.onboarding.installingDistro": "Installing {{distro}}...",
  "wsl.onboarding.checkingDistro": "Checking {{distro}}...",
  "wsl.onboarding.listingDistros": "Listing distros...",
  "wsl.onboarding.distroReady": "{{distro}} is ready.",
  "wsl.onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "wsl.onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "wsl.onboarding.finishingDistro": "Finishing setup for {{distro}}.",
  "wsl.onboarding.pickDistro": "Pick a distro or install one below.",
  "wsl.onboarding.checkingOpencode": "Checking OpenCode...",
  "wsl.onboarding.checkingOpencodeIn": "Checking OpenCode in {{distro}}...",
  "wsl.onboarding.updatingOpencode": "Updating OpenCode...",
  "wsl.onboarding.updatingOpencodeIn": "Updating OpenCode in {{distro}}...",
  "wsl.onboarding.updateOpencodeIn": "Update OpenCode in {{distro}}.",
  "wsl.onboarding.updateOpencode": "Update OpenCode",
  "wsl.onboarding.opencodeReadyIn": "OpenCode is ready in {{distro}}.",
  "wsl.onboarding.opencodeReady": "OpenCode is ready.",
  "wsl.onboarding.installOpencodeIn": "Install OpenCode in {{distro}}.",
  "wsl.onboarding.installOpencode": "Install OpenCode",
  "wsl.onboarding.chooseDistroFirst": "Choose a distro first.",
  "wsl.onboarding.loadFailed": "Failed to load WSL state.",
  "wsl.onboarding.loading": "Loading...",
  "wsl.onboarding.installedDistros": "Installed distros",
  "wsl.onboarding.checkAgain": "Check again",
  "wsl.onboarding.distroStatus.ready": "Ready",
  "wsl.onboarding.distroStatus.checking": "Checking...",
  "wsl.onboarding.distroStatus.opencodeMissing": "OpenCode not installed",
  "wsl.onboarding.distroStatus.missingTools": "Missing bash, curl",
  "wsl.onboarding.distroStatus.unsupported": "Unsupported · Use WSL 2",
  "wsl.onboarding.needAnotherDistro": "Need another distro?",
  "wsl.onboarding.needAnotherDistroHint": "Install a Linux distribution from the WSL catalog",
  "wsl.onboarding.wslNotInstalled.title": "WSL not installed",
  "wsl.onboarding.wslNotInstalled.description":
    "WSL (Windows Subsystem for Linux) is required before OpenCode can add a WSL server",
  "wsl.onboarding.wslUnavailable.title": "WSL unavailable",
  "wsl.onboarding.wslUnavailable.description": "OpenCode could not verify WSL on this machine.",
  "wsl.onboarding.installWsl": "Install WSL",
  "wsl.onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OpenCode.",
  "wsl.onboarding.next": "Next",
  "wsl.onboarding.refresh": "Refresh",
  "wsl.onboarding.allDistrosAdded": "All installed distros are already added.",
  "wsl.onboarding.noDistros": "No distros detected yet.",
  "wsl.onboarding.install": "Install",
  "wsl.onboarding.installing": "Installing...",
  "wsl.onboarding.installDistro": "Install distro",
  "wsl.onboarding.searchDistros": "Search distros",
  "wsl.onboarding.wsl2Required": "WSL 2 is required.",
  "wsl.onboarding.toolsRequired": "This distro needs bash and curl.",
  "wsl.onboarding.openTerminal": "Open terminal",
  "wsl.onboarding.path": "Path: {{path}}",
  "wsl.onboarding.notFound": "not found",
  "wsl.onboarding.version": "Version: {{version}}",
  "wsl.onboarding.unknown": "unknown",
  "wsl.onboarding.desktopVersion": "desktop {{version}}",
  "wsl.onboarding.versionMismatch": "Installed version does not match the desktop app version.",
  "wsl.onboarding.adding": "Adding...",

  "help.tabs.toast.ariaLabel": "Introducing Tabs. Organize your work and active sessions with tabs",
  "help.tabs.toast.dismiss": "Dismiss Tabs information",
  "help.tabs.title": "Introducing Tabs",
  "help.tabs.description": "Organize your work and active sessions with tabs",
  "help.tabs.date": "July 14",
  "help.tabs.introduction": "OpenCode Desktop is now built around tabs.",
  "help.tabs.sessions":
    "Start a new session in a tab, or open an existing session from any of your projects. Open a new tab when you're starting something new, and close it when you're done.",
  "help.tabs.organize":
    "Keeping a few tabs open makes it easier to organize your active sessions. Rename tabs to something memorable if you plan to keep them around.",
  "help.tabs.home":
    "You'll find all your sessions and projects on the new Home screen. Selecting a session opens it in a tab.",
  "help.tabs.persistence": "When you reopen the app, your tabs are still open.",
  "help.tabs.worktrees":
    "The new design does not support Git Worktrees yet, it's coming soon. So if you'd prefer to continue using the previous layout, you can switch between layouts in Settings. Just keep in mind that the new layout will become permanent in a few weeks.",
  "server.row.noUsername": "no username",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.name": "Name",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.icon.hint": "Click or drag an image",
  "dialog.project.edit.icon.recommended": "Recommended: 128x128px",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Workspace startup script",
  "dialog.project.edit.worktree.startup.description": "Runs after creating a new workspace (worktree).",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",

  "dialog.releaseNotes.action.getStarted": "Get started",
  "dialog.releaseNotes.action.next": "Next",
  "dialog.releaseNotes.action.hideFuture": "Don't show these in the future",
  "dialog.releaseNotes.media.alt": "Release preview",
  "dialog.usageExceeded.dontShowAgain": "Don't show again",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",
  "context.export.session": "Export session",

  "context.stats.session": "Session",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.sessionCreated": "Session Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Usage",
  "context.usage.cost": "Cost",
  "context.usage.clickToView": "Click to view context",
  "context.usage.view": "View context usage",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.uk": "Українська",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "Language",
  "toast.language.description": "Switched to {{language}}",

  "toast.theme.title": "Theme switched",
  "toast.scheme.title": "Color scheme",

  "toast.workspace.enabled.title": "Workspaces enabled",
  "toast.workspace.enabled.description": "Multiple worktrees are now shown in the sidebar",
  "toast.workspace.disabled.title": "Workspaces disabled",
  "toast.workspace.disabled.description": "Only the main worktree is shown in the sidebar",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.model.none.title": "No model selected",
  "toast.model.none.description": "Connect a provider to summarize this session",

  "toast.file.loadFailed.title": "Failed to load file",
  "toast.file.listFailed.title": "Failed to list files",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.share.copyFailed.title": "Failed to copy URL to clipboard",
  "toast.session.share.success.title": "Session shared",
  "toast.session.share.success.description": "Share URL copied to clipboard!",
  "toast.session.share.failed.title": "Failed to share session",
  "toast.session.share.failed.description": "An error occurred while sharing the session",

  "toast.session.unshare.success.title": "Session unshared",
  "toast.session.unshare.success.description": "Session unshared successfully!",
  "toast.session.unshare.failed.title": "Failed to unshare session",
  "toast.session.unshare.failed.description": "An error occurred while unsharing the session",

  "toast.session.export.success.title": "Session exported",
  "toast.session.export.success.description": "Saved session to {{filename}}",
  "toast.session.export.failed.title": "Failed to export session",
  "toast.session.export.failed.description": "An error occurred while exporting the session",

  "toast.session.listFailed.title": "Failed to load sessions for {{project}}",
  "toast.project.reloadFailed.title": "Failed to reload {{project}}",

  "toast.update.title": "Update available",
  "toast.update.description": "A new version of OpenCode ({{version}}) is now available to install.",
  "toast.update.action.installRestart": "Install and restart",
  "toast.update.action.notYet": "Not yet",

  "error.page.title": "Something went wrong",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.description.localServerStartup": "An error occurred while starting the local server.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.exportLogs": "Export Logs",
  "error.page.action.checking": "Checking...",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "Please report this error to the OpenCode team",
  "error.page.report.discord": "on Discord",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.serverSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.serverSDK.noServerAvailable": "No server available",
  "error.serverSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (opencode.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OpenCode does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "{{sessionTitle}} in {{projectName}} needs permission",
  "notification.question.title": "Question",
  "notification.question.description": "{{sessionTitle}} in {{projectName}} has a question",
  "notification.action.goToSession": "Go to session",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.recentProjects": "Recent projects",
  "home.empty.title": "No recent projects",
  "home.empty.description": "Get started by opening a local project",
  "home.title": "Home",
  "home.projects": "Projects",
  "home.project.add": "Add project",
  "home.recentlyClosed": "Recently closed",
  "home.server.collapse": "Collapse server projects",
  "home.server.expand": "Expand server projects",
  "home.sessions.search.placeholder": "Search sessions",
  "home.sessions.search.placeholder.scoped": "Search sessions in {{scope}}",
  "home.sessions.search.sessions": "Sessions",
  "home.sessions.search.noResults": "No sessions found for {{query}}",
  "home.sessions.empty": "Nothing here yet",
  "home.sessions.empty.description": "Create a session to get started",
  "home.sessions.group.today": "Today",
  "home.sessions.group.yesterday": "Yesterday",
  "home.sessions.group.older": "Older",
  "home.providerTip": "Connect to 75+ providers to use other models, including Claude, GPT, Gemini, etc",

  "session.tab.session": "Session",
  "session.tab.review": "Review",
  "session.tab.context": "Context",
  "session.tab.unknown": "Unknown Session",
  "session.panel.reviewAndFiles": "Review and files",
  "session.error.notFound": "This session cannot be found",
  "session.error.notFound.description": "This tab points to a session that no longer exists on this server.",
  "session.error.notFound.closeTab": "Close Tab",
  "session.error.serverConnection": "Can't connect to this server",
  "session.review.filesChanged": "Files Changed {{count}}",
  "session.review.change.one": "Change",
  "session.review.change.other": "Changes",
  "session.review.loadingChanges": "Loading changes...",
  "session.review.empty": "No changes in this session yet",
  "session.review.noVcs": "No Git Version Control System detected, changes not displayed",
  "session.review.noVcs.createGit.title": "Create a Git repository",
  "session.review.noVcs.createGit.description": "Track, review, and undo changes in this project",
  "session.review.noVcs.createGit.actionLoading": "Creating Git repository...",
  "session.review.noVcs.createGit.action": "Create Git repository",
  "session.review.noSnapshot": "Snapshot tracking is disabled in config, so session changes are unavailable",
  "session.review.noChanges": "No changes",
  "session.review.noUncommittedChanges": "No uncommitted changes yet",
  "session.review.noBranchChanges": "No branch changes yet",

  "session.files.selectToOpen": "Select a file to open",
  "session.files.all": "All files",
  "session.files.empty": "No files",
  "session.files.binaryContent": "Binary file (content cannot be displayed)",

  "session.messages.renderEarlier": "Render earlier messages",
  "session.messages.loadingEarlier": "Loading earlier messages...",
  "session.messages.loadEarlier": "Load earlier messages",
  "session.messages.loading": "Loading messages...",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.context.addToContext": "Add {{selection}} to context",
  "session.todo.title": "Todos",
  "session.todo.collapse": "Collapse",
  "session.todo.expand": "Expand",
  "session.todo.progress": "{{done}} of {{total}} todos completed",
  "session.question.progress": "{{current}} of {{total}} questions",
  "session.question.minimize": "Minimize question",
  "session.question.restore": "Restore question",
  "session.question.pending.one": "{{count}} pending question",
  "session.question.pending.other": "{{count}} pending questions",
  "session.followupDock.summary.one": "{{count}} queued message",
  "session.followupDock.summary.other": "{{count}} queued messages",
  "session.followupDock.sendNow": "Send now",
  "session.followupDock.edit": "Edit",
  "session.followupDock.collapse": "Collapse queued messages",
  "session.followupDock.expand": "Expand queued messages",
  "session.revertDock.summary.one": "{{count}} rolled back message",
  "session.revertDock.summary.other": "{{count}} rolled back messages",
  "session.revertDock.collapse": "Collapse rolled back messages",
  "session.revertDock.expand": "Expand rolled back messages",
  "session.revertDock.restore": "Restore message",

  "session.new.title": "Build anything",
  "session.new.project.new": "New project",
  "session.new.project.search": "Search projects",
  "session.new.project.add": "Add project",
  "session.new.worktree.main": "Main branch",
  "session.new.worktree.mainWithBranch": "Main branch ({{branch}})",
  "session.new.worktree.create": "Create new worktree",
  "session.new.workspace.runIn": "Run session in",
  "session.new.workspace.triggerLocal": "Local",
  "session.new.workspace.local": "Local repository",
  "session.new.workspace.existing": "Workspace…",
  "session.new.git.none": "No Git",
  "session.new.lastModified": "Last modified",

  "session.header.search.placeholder": "Search {{project}}",
  "session.header.searchFiles": "Search files",
  "session.header.openIn": "Open in",
  "session.header.open.action": "Open {{app}}",
  "session.header.open.ariaLabel": "Open in {{app}}",
  "session.header.open.menu": "Open options",
  "session.header.open.copyPath": "Copy path",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.reveal.finder": "Reveal in Finder",
  "session.header.reveal.fileExplorer": "Reveal in File Explorer",
  "session.header.reveal.containingFolder": "Open containing folder",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "Terminal",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",

  "status.popover.trigger": "Status",
  "status.popover.ariaLabel": "Server configurations",
  "status.popover.tab.servers": "Servers",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "Plugins",
  "status.popover.action.manageServers": "Manage servers",

  "session.share.popover.title": "Publish on web",
  "session.share.popover.description.shared":
    "This session is public on the web. It is accessible to anyone with the link.",
  "session.share.popover.description.unshared":
    "Share session publicly on the web. It will be accessible to anyone with the link.",
  "session.share.action.share": "Share",
  "session.share.action.publish": "Publish",
  "session.share.action.publishing": "Publishing...",
  "session.share.action.unpublish": "Unpublish",
  "session.share.action.unpublishing": "Unpublishing...",
  "session.share.action.view": "View",
  "session.share.copy.copied": "Copied",
  "session.share.copy.copyLink": "Copy link",

  "lsp.tooltip.none": "No LSP servers",
  "lsp.label.connected": "{{count}} LSP",

  "prompt.loading": "Loading prompt...",
  "terminal.loading": "Loading terminal...",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",
  "terminal.connectTicket.csrfError":
    "PTY connect ticket rejected by origin or CSRF checks. Check the server CORS config.",
  "terminal.connectTicket.statusError": "PTY connect ticket failed with {{status}}",

  "titlebar.update": "Update",
  "titlebar.updateVersion": "Update {{version}}",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.export": "Export",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.menu.toggle": "Toggle menu",
  "sidebar.nav.projectsAndSessions": "Projects and sessions",
  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.workspaces.enable": "Enable workspaces",
  "sidebar.workspaces.disable": "Disable workspaces",
  "sidebar.gettingStarted.title": "Getting started",
  "sidebar.gettingStarted.line1": "OpenCode includes free models so you can start immediately.",
  "sidebar.gettingStarted.line2": "Connect any provider to use models, inc. Claude, GPT, Gemini etc.",
  "sidebar.project.recentSessions": "Recent sessions",
  "sidebar.project.viewAllSessions": "View all sessions",
  "sidebar.project.clearNotifications": "Clear notifications",
  "sidebar.empty.title": "No projects open",
  "sidebar.empty.description": "Open a project to get started",

  "debugBar.ariaLabel": "Development performance diagnostics",
  "debugBar.toggle": "Toggle debug tools",
  "debugBar.na": "n/a",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip":
    "Last completed route transition touching a session page, measured from router start until the first paint after it settles.",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "Rolling frames per second over the last 5 seconds.",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "Worst frame time over the last 5 seconds.",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "Frames over 32ms in the last 5 seconds.",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "Worst observed input delay in the last 5 seconds.",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "Cumulative layout shift for the current app lifetime.",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "debugBar.mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",
  "debugBar.focus.label": "FOCUS",
  "debugBar.focus.tip": "Force focus styles on all interactive elements",
  "debugBar.focus.on": "ON",
  "debugBar.focus.off": "OFF",
  "debugBar.direction.label": "DIR",
  "debugBar.direction.tip": "Force the full app layout direction without changing the selected language",
  "debugBar.direction.ltr": "LTR",
  "debugBar.direction.rtl": "RTL",

  "app.name.desktop": "OpenCode Desktop",

  "settings.section.desktop": "Desktop",
  "settings.section.server": "Server",
  "settings.tab.general": "General",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL integration",
  "settings.desktop.wsl.description": "Run the OpenCode server inside WSL on Windows.",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.advanced": "Advanced",
  "settings.general.section.notifications": "System notifications",
  "settings.general.section.updates": "Updates",
  "settings.general.section.sounds": "Sound effects",
  "settings.general.section.feed": "Feed",
  "settings.general.section.display": "Display",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for OpenCode",
  "settings.general.row.shell.title": "Terminal shell",
  "settings.general.row.shell.description": "Shell used by the terminal and agent tools",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.appearance.title": "Appearance",
  "settings.general.row.appearance.description": "Customise how OpenCode looks on your device",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OpenCode follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OpenCode is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.followup.title": "Follow-up behavior",
  "settings.general.row.followup.description": "Choose whether follow-up prompts steer immediately or wait in a queue",
  "settings.general.row.followup.option.queue": "Queue",
  "settings.general.row.followup.option.steer": "Steer",
  "settings.general.row.showFileTree.title": "File tree",
  "settings.general.row.showFileTree.description": "Show the file tree panel in sessions",
  "settings.general.row.showNavigation.title": "Navigation controls",
  "settings.general.row.showNavigation.description": "Show the back and forward buttons in the desktop title bar",
  "settings.general.row.showSearch.title": "Command palette",
  "settings.general.row.showSearch.description": "Show the search and command palette button in the title bar",
  "settings.general.row.showTerminal.title": "Terminal",
  "settings.general.row.showTerminal.description": "Show the terminal button in the desktop title bar",
  "settings.general.row.showStatus.title": "Server status",
  "settings.general.row.showStatus.description": "Show the server status button in the title bar",
  "settings.general.row.mobileTitlebarBottom.title": "Bottom navigation",
  "settings.general.row.mobileTitlebarBottom.description":
    "Place the title bar and session tabs at the bottom of the screen on mobile",
  "settings.general.row.showCustomAgents.title": "Show agent",
  "settings.general.row.showCustomAgents.description":
    "Switch between agents in the composer. When hidden, defaults to Build agent.",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",
  "settings.general.row.shellToolPartsExpanded.title": "Expand shell tool parts",
  "settings.general.row.shellToolPartsExpanded.description":
    "Show shell tool parts expanded by default in the timeline",
  "settings.general.row.editToolPartsExpanded.title": "Expand edit tool parts",
  "settings.general.row.editToolPartsExpanded.description":
    "Show edit, write, and patch tool parts expanded by default in the timeline",
  "settings.general.row.newInterface.title": "New layout",
  "settings.general.row.newInterface.badge": "New",
  "settings.general.row.newInterface.description":
    "Use the new tabs and home layout. Switch between layouts for a limited time.",
  "settings.general.row.newInterfaceNotice.title": "You're now using new layout",
  "settings.general.row.newInterfaceNotice.description": "The previous layout is no longer available",
  "settings.general.row.newInterfaceNotice.dismiss": "Dismiss",
  "settings.general.row.pinchZoom.title": "Pinch to zoom",
  "settings.general.row.pinchZoom.description": "Allow trackpad pinch and Ctrl-scroll gestures to zoom",

  "settings.general.row.wayland.title": "Use native Wayland",
  "settings.general.row.wayland.description": "Disable X11 fallback on Wayland. Requires restart.",
  "settings.general.row.wayland.tooltip":
    "On Linux with mixed refresh-rate monitors, native Wayland can be more stable.",

  "settings.general.row.releaseNotes.title": "Release notes",
  "settings.general.row.releaseNotes.description": "Show What's New popups after updates",

  "settings.updates.row.startup.title": "Check for updates on startup",
  "settings.updates.row.startup.description": "Automatically check for updates when OpenCode launches",
  "settings.updates.row.check.title": "Check for updates",
  "settings.updates.row.check.description": "Manually check for updates and install if available",
  "settings.updates.action.checkNow": "Check now",
  "settings.updates.action.checking": "Checking...",
  "settings.updates.action.downloading": "Downloading...",
  "settings.updates.action.installing": "Installing...",
  "settings.updates.toast.latest.title": "You're up to date",
  "settings.updates.toast.latest.description": "You're running the latest version of OpenCode.",
  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",
  "settings.shortcuts.search.empty": "No shortcuts found",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Session",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Provider settings will be configurable here.",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.custom.description": "Add an OpenAI-compatible provider by base URL.",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.other": "Other",
  "settings.models.title": "Models",
  "settings.models.description": "Model settings will be configurable here.",
  "settings.agents.title": "Agents",
  "settings.agents.description": "Agent settings will be configurable here.",
  "settings.commands.title": "Commands",
  "settings.commands.description": "Command settings will be configurable here.",
  "settings.mcp.title": "MCP",
  "settings.mcp.description": "MCP settings will be configurable here.",

  "settings.permissions.title": "Permissions",
  "settings.permissions.description": "Control what tools the server can use by default.",
  "settings.permissions.section.tools": "Tools",
  "settings.permissions.toast.updateFailed.title": "Failed to update permissions",

  "settings.permissions.action.allow": "Allow",
  "settings.permissions.action.ask": "Ask",
  "settings.permissions.action.deny": "Deny",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, and patches",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New workspace",
  "workspace.type.local": "local",
  "workspace.type.sandbox": "sandbox",
  "workspace.create.failed.title": "Failed to create workspace",
  "workspace.delete.failed.title": "Failed to delete workspace",
  "workspace.resetting.title": "Resetting workspace",
  "workspace.resetting.description": "This may take a minute.",
  "workspace.reset.failed.title": "Failed to reset workspace",
  "workspace.reset.success.title": "Workspace reset",
  "workspace.reset.success.description": "Workspace now matches the default branch.",
  "workspace.error.stillPreparing": "Workspace is still preparing",
  "workspace.status.checking": "Checking for unmerged changes...",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.clean": "No unmerged changes detected.",
  "workspace.status.dirty": "Unmerged changes detected in this workspace.",
  "workspace.delete.title": "Delete workspace",
  "workspace.delete.confirm": 'Delete workspace "{{name}}"?',
  "workspace.delete.button": "Delete workspace",
  "workspace.reset.title": "Reset workspace",
  "workspace.reset.confirm": 'Reset workspace "{{name}}"?',
  "workspace.reset.button": "Reset workspace",
  "workspace.reset.archived.none": "No active sessions will be archived.",
  "workspace.reset.archived.one": "1 session will be archived.",
  "workspace.reset.archived.many": "{{count}} sessions will be archived.",
  "workspace.reset.note": "This will reset the workspace to match the default branch.",

  "cowork.kicker": "Andmera Agent",
  "cowork.runtime.name": "Andmera Report Agent",
  "cowork.logo.alt": "Andmera logo",
  "cowork.error.contactSupport": "Please contact Andmera support if this error continues.",
  "cowork.prompt.uploadFiles": "Upload files",
  "cowork.prompt.upload.uploading": "Uploading",
  "cowork.prompt.upload.uploaded": "Uploaded",
  "cowork.prompt.upload.failed": "Failed",
  "cowork.prompt.placeholder": "I want...",
  "cowork.title": "Custom report automation",
  "cowork.subtitle":
    "Create a project, upload source files, and chat with the Andmera report agent to extract, transform, and generate customer reports.",
  "cowork.apiBase": "API: {{url}}",
  "cowork.company.label": "Company",
  "cowork.company.option": "{{name}} ({{role}})",
  "cowork.enterprise.brand": "Andmera",
  "cowork.enterprise.workspace.defaultName": "My workspace",
  "cowork.enterprise.nav.dashboard": "Dashboard",
  "cowork.enterprise.nav.workspace": "Workspace",
  "cowork.enterprise.nav.companies": "Companies",
  "cowork.enterprise.nav.reports": "Reports",
  "cowork.enterprise.nav.dataSources": "Data Sources",
  "cowork.enterprise.chats.title": "Chats",
  "cowork.enterprise.chats.description":
    "Search and continue conversations across the current company and project scope.",
  "cowork.enterprise.chats.search": "Search chats...",
  "cowork.enterprise.search.title": "Search workspace",
  "cowork.enterprise.search.placeholder": "Search chats and files...",
  "cowork.enterprise.search.clear": "Clear",
  "cowork.enterprise.search.close": "Close search",
  "cowork.enterprise.search.all": "All",
  "cowork.enterprise.search.chats": "Chats",
  "cowork.enterprise.search.files": "Files",
  "cowork.enterprise.search.empty": "No matching chats or files found.",
  "cowork.enterprise.chats.chat": "Chat",
  "cowork.enterprise.chats.messages": "Messages",
  "cowork.enterprise.chats.lastActivity": "Last activity",
  "cowork.enterprise.chats.empty": "No chats are available in the current scope.",
  "cowork.enterprise.chats.opening": "Opening...",
  "cowork.enterprise.chats.unavailable": "This chat could not be opened.",
  "cowork.enterprise.chats.untitled": "Chat",
  "cowork.enterprise.chats.closeTab": "Close chat tab",
  "cowork.enterprise.chats.allOpen": "All open chats",
  "cowork.enterprise.chats.scrollLeft": "Scroll tabs left",
  "cowork.enterprise.chats.scrollRight": "Scroll tabs right",
  "cowork.enterprise.chats.continue": "Continue chat",
  "cowork.chatDock.connectionUnavailable": "Chat connection unavailable",
  "cowork.chatDock.connectionRecovery": "This tab uses a server connection that is no longer active. Continue the chat to reconnect, or close this tab.",
  "cowork.enterprise.chats.rename": "Rename chat",
  "cowork.enterprise.chats.renameTitle": "Rename chat",
  "cowork.enterprise.chats.renameDescription": "Choose a clear name to make this chat easier to find later.",
  "cowork.enterprise.chats.renameLabel": "Chat name",
  "cowork.enterprise.chats.saveName": "Save name",
  "cowork.enterprise.chats.renaming": "Saving...",
  "cowork.enterprise.chats.delete": "Delete chat",
  "cowork.enterprise.chats.deleteTitle": "Delete chat?",
  "cowork.enterprise.chats.deleteDescription":
    "Delete “{{chat}}”? This removes the chat and its message history from Andmera.",
  "cowork.enterprise.chats.confirmDelete": "Delete chat",
  "cowork.enterprise.chats.deleting": "Deleting...",
  "cowork.enterprise.nav.agents": "Agents",
  "cowork.enterprise.nav.myAgents": "My Agents",
  "cowork.enterprise.nav.agentLibrary": "Agent Library",
  "cowork.enterprise.nav.automation": "Automation",
  "cowork.enterprise.nav.control": "Control",
  "cowork.enterprise.nav.activity": "Activity",
  "cowork.enterprise.nav.auditLog": "Audit Log",
  "cowork.enterprise.nav.platform": "Platform",
  "cowork.enterprise.nav.accessRequests": "Access requests",
  "cowork.accessRequests.title": "Access requests",
  "cowork.accessRequests.description":
    "Firms that asked for early access. Approving creates their workspace and emails an owner invitation.",
  "cowork.accessRequests.filter": "Show",
  "cowork.accessRequests.filter.pending": "Pending",
  "cowork.accessRequests.filter.all": "All",
  "cowork.accessRequests.loading": "Loading requests...",
  "cowork.accessRequests.empty": "No pending requests",
  "cowork.accessRequests.emptyDescription": "New requests from the website appear here.",
  "cowork.accessRequests.workspaceName": "Workspace name",
  "cowork.accessRequests.approve": "Approve",
  "cowork.accessRequests.decline": "Decline",
  "cowork.accessRequests.working": "Working...",
  "cowork.accessRequests.approved": "Workspace created and an owner invitation sent to {{email}}.",
  "cowork.accessRequests.declined": "Request from {{email}} declined.",
  "cowork.accessRequests.done": "Done",
  "cowork.accessRequests.error": "Request failed",
  "cowork.accessRequests.status.requested": "Pending",
  "cowork.accessRequests.status.approved": "Approved",
  "cowork.accessRequests.status.declined": "Declined",
  "cowork.enterprise.nav.settings": "Settings",
  "cowork.enterprise.nav.workspaceSettings": "Workspace Settings",
  "cowork.enterprise.settings.general": "Application",
  "cowork.enterprise.settings.workspace": "Workspace",
  "cowork.enterprise.settings.generalDescription": "Manage application appearance and behavior.",
  "cowork.enterprise.settings.workspaceDescription": "Invite team members and configure shared workspace defaults.",
  "cowork.enterprise.settings.workspaceIdentity": "Workspace identity",
  "cowork.enterprise.settings.workspaceName": "Workspace name",
  "cowork.enterprise.settings.workspaceNameDescription":
    "This name identifies the shared workspace in the application navigation.",
  "cowork.enterprise.settings.save": "Save",
  "cowork.enterprise.settings.saving": "Saving...",
  "cowork.enterprise.settings.defaultAgent": "Default agent",
  "cowork.enterprise.settings.defaultAgentDescription":
    "This agent is selected by default for new conversations created in the workspace.",
  "cowork.enterprise.settings.systemDefaultAgent": "System default agent",
  "cowork.enterprise.settings.members": "Workspace members",
  "cowork.enterprise.settings.inviteMember": "Invite member",
  "cowork.enterprise.settings.inviteDescription":
    "Send an email invitation. The person gets access to the companies and projects managed by this workspace once they accept.",
  "cowork.enterprise.settings.seats": "Seats",
  "cowork.enterprise.settings.seatUsage": "{{used}} of {{limit}} seats used",
  "cowork.enterprise.settings.trial": "Trial",
  "cowork.enterprise.settings.trialUsage":
    "Client companies: {{companies}} of {{companyLimit}} · Reports: {{reports}} of {{reportLimit}}",
  "cowork.trial.projects": "Projects: {{used}} of {{limit}}",
  "cowork.trial.storage": "File storage: {{used}} of {{limit}} MB",
  "cowork.trial.chats": "Chats: {{used}} of {{limit}}",
  "cowork.trial.messages": "Agent requests: {{used}} of {{limit}}",
  "cowork.trial.ends": "Trial ends on {{date}}",
  "cowork.trial.expired": "Trial ended on {{date}}. Existing work is still available to read and download.",
  "cowork.trial.error.expired": "Your trial has ended. Existing work remains available; upgrade to continue creating content.",
  "cowork.trial.error.project": "The trial project limit has been reached.",
  "cowork.trial.error.storage": "The trial storage limit has been reached.",
  "cowork.trial.error.chat": "The trial chat limit has been reached.",
  "cowork.trial.error.message": "The trial agent request limit has been reached.",
  "cowork.enterprise.settings.memberIdentifier": "Email address",
  "cowork.enterprise.settings.invitations.sent": "Invitation sent",
  "cowork.enterprise.settings.invitations.sentDescription": "An email with an invitation link was sent to {{email}}.",
  "cowork.enterprise.settings.invitations.pending": "Pending invitations",
  "cowork.enterprise.settings.invitations.expires": "Invitation expires on {{date}}",
  "cowork.enterprise.settings.invitations.resend": "Resend",
  "cowork.enterprise.settings.invitations.revoke": "Revoke",
  "cowork.enterprise.settings.invitations.deliveryFailed":
    "The invitation was saved but the email could not be delivered. Check the email address or the sending domain, then use Resend.",
  "cowork.enterprise.settings.invitations.seatLimitReached":
    "This workspace has used all {{limit}} seats. Remove a member or revoke a pending invitation before inviting someone else.",
  "cowork.enterprise.settings.memberRole": "Workspace role",
  "cowork.enterprise.settings.role.member": "Member",
  "cowork.enterprise.settings.role.admin": "Admin",
  "cowork.enterprise.settings.role.owner": "Owner",
  "cowork.enterprise.settings.invite": "Invite",
  "cowork.enterprise.settings.inviting": "Inviting...",
  "cowork.enterprise.settings.error": "Workspace update failed",
  "cowork.enterprise.settings.currentMembers": "Current members",
  "cowork.enterprise.settings.loadingMembers": "Loading workspace members...",
  "cowork.enterprise.settings.noMembers": "No workspace members yet",
  "cowork.enterprise.settings.noMembersDescription": "Invited team members will appear here.",
  "cowork.enterprise.settings.entityAccess": "Access to {{count}} entities",
  "cowork.enterprise.nav.open": "Open navigation",
  "cowork.enterprise.nav.close": "Close navigation",
  "cowork.enterprise.scope.workspace": "Workspace",
  "cowork.enterprise.scope.entity": "Company / Entity",
  "cowork.enterprise.scope.project": "Project",
  "cowork.enterprise.scope.period": "Accounting period",
  "cowork.enterprise.scope.allCompanies": "All Companies",
  "cowork.enterprise.scope.allProjects": "All Projects",
  "cowork.enterprise.scope.selectCompany": "Select company",
  "cowork.enterprise.scope.selectProject": "Select project",
  "cowork.enterprise.scope.expandSwitchers": "Expand scope selectors",
  "cowork.enterprise.scope.collapseSwitchers": "Collapse scope selectors",
  "cowork.enterprise.scope.allPeriods": "All Periods",
  "cowork.enterprise.period.current": "Current",
  "cowork.enterprise.period.currentOption": "{{period}} · Current",
  "cowork.enterprise.period.accountingPeriod": "Accounting period",
  "cowork.enterprise.period.title": "Periods",
  "cowork.enterprise.period.description": "Organize files, reports, and chats by reporting period.",
  "cowork.enterprise.period.empty": "No periods yet. Create one to organize periodic work.",
  "cowork.enterprise.period.allPeriodsDescription": "Viewing data across every accounting period in this project.",
  "cowork.enterprise.period.new": "New period",
  "cowork.enterprise.period.add": "Add period",
  "cowork.enterprise.period.close": "Close period",
  "cowork.enterprise.period.reopen": "Reopen period",
  "cowork.enterprise.period.name": "Period name",
  "cowork.enterprise.period.namePlaceholder": "January 2026",
  "cowork.enterprise.period.granularity": "Period granularity",
  "cowork.enterprise.period.granularity.year": "Yearly",
  "cowork.enterprise.period.granularity.quarter": "Quarterly",
  "cowork.enterprise.period.granularity.month": "Monthly",
  "cowork.enterprise.period.granularity.day": "Daily",
  "cowork.enterprise.period.granularity.custom": "Custom",
  "cowork.enterprise.period.startDate": "Period start date",
  "cowork.enterprise.period.endDate": "Period end date",
  "cowork.enterprise.period.from": "From",
  "cowork.enterprise.period.to": "To",
  "cowork.enterprise.period.day": "Select day",
  "cowork.enterprise.period.create": "Create period",
  "cowork.enterprise.period.creating": "Creating...",
  "cowork.enterprise.period.status.open": "Open",
  "cowork.enterprise.period.status.processing": "Processing",
  "cowork.enterprise.period.status.needsReview": "Needs Review",
  "cowork.enterprise.period.status.closing": "Closing",
  "cowork.enterprise.period.status.closed": "Closed",
  "cowork.enterprise.period.status.locked": "Locked",
  "cowork.enterprise.profile.user": "Workspace member",
  "cowork.enterprise.profile.member": "Workspace member",
  "cowork.enterprise.profile.menu": "Open profile menu",
  "cowork.enterprise.profile.signOut": "Sign out",
  "cowork.enterprise.search.label": "Search workspace",
  "cowork.enterprise.notifications": "Notifications",
  "cowork.enterprise.help": "Help",
  "cowork.enterprise.newChat": "New chat",
  "cowork.enterprise.dashboard.groupTitle": "Workspace overview",
  "cowork.enterprise.dashboard.entityTitle": "{{entity}} overview",
  "cowork.enterprise.dashboard.groupSubtitle": "Monitor work, decisions, and results across your organization.",
  "cowork.enterprise.dashboard.entitySubtitle": "Monitor data, reports, agents, and workflows for {{entity}}.",
  "cowork.enterprise.dashboard.export": "Export",
  "cowork.enterprise.dashboard.companies": "Companies",
  "cowork.enterprise.dashboard.projects": "Projects",
  "cowork.enterprise.dashboard.activeEntities": "Active entities in this workspace",
  "cowork.enterprise.dashboard.inCurrentScope": "In the current scope",
  "cowork.enterprise.dashboard.generatedReports": "Generated reports",
  "cowork.enterprise.dashboard.activeWorkflows": "Configured workflows",
  "cowork.enterprise.dashboard.needsAttention": "Needs attention",
  "cowork.enterprise.dashboard.reviewItems": "Review and approval items",
  "cowork.enterprise.dashboard.workflowActivity": "Workflow activity",
  "cowork.enterprise.dashboard.workflowSubtitle": "{{count}} recent workflows",
  "cowork.enterprise.dashboard.viewAllWorkflows": "View all workflows",
  "cowork.enterprise.dashboard.workflowAgent": "Workflow / Agent",
  "cowork.enterprise.dashboard.scope": "Scope",
  "cowork.enterprise.dashboard.updated": "Updated",
  "cowork.enterprise.dashboard.automationWorkflow": "Automation workflow",
  "cowork.enterprise.dashboard.noWorkflows": "No workflows are available in this scope yet.",
  "cowork.enterprise.dashboard.attentionRequired": "Attention required",
  "cowork.enterprise.dashboard.noAttention": "Nothing requires attention right now.",
  "cowork.enterprise.dashboard.companyPortfolio": "Company portfolio",
  "cowork.enterprise.dashboard.compare": "Compare",
  "cowork.enterprise.dashboard.noCompanies": "No companies have been added to this workspace.",
  "cowork.enterprise.dashboard.companyRole": "{{role}} access",
  "cowork.enterprise.dashboard.recentReports": "Recent reports",
  "cowork.enterprise.dashboard.viewReports": "View reports",
  "cowork.enterprise.dashboard.noReports": "No recent reports in this scope.",
  "cowork.enterprise.dashboard.recently": "Recently",
  "cowork.enterprise.dashboard.justNow": "Just now",
  "cowork.enterprise.dashboard.minutesAgo": "{{count}}m ago",
  "cowork.enterprise.dashboard.hoursAgo": "{{count}}h ago",
  "cowork.enterprise.status.active": "Active",
  "cowork.enterprise.status.live": "Live",
  "cowork.enterprise.status.ready": "Ready",
  "cowork.enterprise.status.processing": "Processing",
  "cowork.enterprise.status.failed": "Failed",
  "cowork.enterprise.common.notAvailable": "Not available",
  "cowork.enterprise.data.files": "Files",
  "cowork.enterprise.data.datasets": "Datasets",
  "cowork.enterprise.data.extracted": "Extracted Data",
  "cowork.enterprise.data.sources": "Connected Sources",
  "cowork.enterprise.data.extractedEmptyTitle": "No extracted data yet",
  "cowork.enterprise.data.extractedEmptyDescription": "Structured data extracted from source files will appear here.",
  "cowork.enterprise.data.sourcesEmptyTitle": "No connected sources",
  "cowork.enterprise.data.sourcesEmptyDescription":
    "Connect a data source to make governed business data available in this scope.",
  "cowork.enterprise.files.description": "Find uploaded source files and datasets across the current business scope.",
  "cowork.enterprise.files.folders": "Folders",
  "cowork.enterprise.files.addFiles": "Add files",
  "cowork.enterprise.files.projectFiles": "Project files",
  "cowork.enterprise.files.selectProject": "Select a company and project to add files or find empty period folders.",
  "cowork.enterprise.files.destination": "Upload destination: {{company}} / {{project}} / {{folder}}",
  "cowork.enterprise.files.locked": "This period is closed or locked. Files cannot be added.",
  "cowork.enterprise.files.partialError":
    "Some files or period folders could not be loaded. This view may be incomplete.",
  "cowork.enterprise.files.uploadUnconfirmed":
    "Could not confirm the upload. The file may already be saved. Check the original destination before retrying; retrying may create a duplicate.",
  "cowork.enterprise.files.uploadScopeMismatch":
    "The server returned a different destination. The file may already be saved. Check the project before retrying; retrying uses the original destination and may create a duplicate.",
  "cowork.enterprise.files.downloadError": "Could not download the file. Please try again.",
  "cowork.enterprise.files.deleteError":
    "Could not confirm deletion or refresh the list. Check the file list before trying again.",
  "cowork.enterprise.files.snapshotEmpty": "No matching files in this snapshot. Try changing the filters.",
  "cowork.enterprise.files.filter.all": "All",
  "cowork.enterprise.files.filter.document": "Documents",
  "cowork.enterprise.files.filter.spreadsheet": "Spreadsheets",
  "cowork.enterprise.files.filter.pdf": "PDF",
  "cowork.enterprise.files.filter.dataset": "Datasets",
  "cowork.enterprise.files.search": "Search files...",
  "cowork.enterprise.files.searchLabel": "Search files",
  "cowork.enterprise.files.emptyTitle": "No files found",
  "cowork.enterprise.files.unavailableSnapshot": "Unavailable input files",
  "cowork.enterprise.files.unnamedPeriod": "Unnamed period",
  "cowork.enterprise.files.emptyDescription": "Upload source data or adjust the current filters.",
  "cowork.enterprise.files.name": "Name",
  "cowork.enterprise.files.type": "Type",
  "cowork.enterprise.files.source": "Source",
  "cowork.enterprise.files.updated": "Uploaded",
  "cowork.enterprise.files.open": "Open",
  "cowork.enterprise.files.actions": "File actions",
  "cowork.enterprise.files.download": "Download",
  "cowork.enterprise.files.selectedCount": "Selected: {{count}}",
  "cowork.enterprise.files.deleteConfirm": "Delete {{name}}?",
  "cowork.enterprise.files.deleting": "Deleting...",
  "cowork.enterprise.reports.description": "Review generated reports and dashboards across companies and projects.",
  "cowork.enterprise.reports.search": "Search reports...",
  "cowork.enterprise.reports.searchLabel": "Search reports",
  "cowork.enterprise.reports.statusFilter": "Filter reports by status",
  "cowork.enterprise.reports.allStatuses": "All statuses",
  "cowork.enterprise.reports.emptyTitle": "No reports found",
  "cowork.enterprise.reports.emptyDescription": "Generated reports for the current scope will appear here.",
  "cowork.enterprise.reports.download": "Download",
  "cowork.enterprise.reports.share": "Share",
  "cowork.report.share.title": "Share report",
  "cowork.report.share.description": "Send a viewing-only link. Recipients can open and download the report.",
  "cowork.report.share.purpose": "Purpose",
  "cowork.report.share.requestApproval": "Request approval",
  "cowork.report.share.recipients": "Recipient emails",
  "cowork.report.share.recipientsPlaceholder": "name@example.com, colleague@example.com",
  "cowork.report.share.messagePlaceholder": "Optional note for recipients",
  "cowork.report.share.send": "Send report",
  "cowork.report.share.sent": "Report sent.",
  "cowork.report.share.deliveryFailed": "Some emails could not be sent. Check the sharing history before resending.",
  "cowork.report.share.history": "Sharing history",
  "cowork.report.share.historyEmpty": "This report has not been shared yet.",
  "cowork.report.share.historyError": "Could not load sharing history.",
  "cowork.report.share.status.pending": "Sending",
  "cowork.report.share.status.sent": "Sent",
  "cowork.report.share.status.failed": "Not sent",
  "cowork.report.share.unavailable": "This shared report is unavailable or the link is invalid.",
  "cowork.report.share.downloadError": "Could not load the report. Please try again.",
  "cowork.report.share.sharedBy": "Shared by {{user}}",
  "cowork.enterprise.reports.exportPdf": "Export PDF",
  "cowork.enterprise.reports.exportingPdf": "Exporting PDF…",
  "cowork.enterprise.reports.exportPdfError": "This workbook could not be exported to PDF. You can still download the Excel file.",
  "cowork.enterprise.reports.exportPdfUnavailable": "PDF export is currently unavailable. Please try again later.",
  "cowork.enterprise.reports.exportPdfBusy": "PDF export is busy. Please try again shortly.",
  "cowork.enterprise.reports.exportPdfTimeout": "PDF export took too long. Please try again or download the Excel file.",
  "cowork.enterprise.reports.status.draft": "Draft",
  "cowork.enterprise.reports.status.readyForReview": "Ready for review",
  "cowork.enterprise.reports.status.approved": "Approved",
  "cowork.enterprise.reports.status.blocked": "Blocked",
  "cowork.enterprise.reports.accounting.partial": "Partial accounting draft — workflow gaps remain.",
  "cowork.enterprise.reports.missingOutput": "Requested output not produced: {{formats}}. This is a review draft, not a complete return.",
  "cowork.enterprise.reports.workingPaper": "Unverified working paper — not ready for approval.",
  "cowork.enterprise.agents.focusSkills": "Preferred skills",
  "cowork.enterprise.agents.focusDescription": "Choose skills for this agent to consider first. It can use other available skills when needed. Changes apply to new chats.",
  "cowork.enterprise.agents.instructions": "Agent guidance",
  "cowork.enterprise.agents.instructionsDescription": "Optional goals and working style for new chats. Workspace access and permissions still apply.",
  "cowork.enterprise.reports.accounting.unverified": "Accounting workflow completeness has not been verified for this report.",
  "cowork.enterprise.reports.accounting.unmapped": "Unresolved posting lines: {{count}}",
  "cowork.enterprise.reports.accounting.sourceReview": "Sources with incomplete accounting evidence: {{count}}. See the workbook review for reasons.",
  "cowork.enterprise.reports.accounting.processingReview": "Sources still requiring agent processing: {{count}}. These are processing tasks, not requests for accountant approval.",
  "cowork.enterprise.reports.accounting.unresolvedAmounts": "Unresolved turnover: debit {{debit}} / credit {{credit}} {{currency}}. These amounts are not GL accounts.",
  "cowork.enterprise.reports.view": "View",
  "cowork.enterprise.reports.closePreview": "Close report preview",
  "cowork.enterprise.reports.loadingPreview": "Loading preview...",
  "cowork.enterprise.reports.previewUnavailable":
    "A browser preview is not available for this file type. Download the report to open it.",
  "cowork.enterprise.reports.previewTitle": "Preview of {{report}}",
  "cowork.enterprise.companies.description": "Manage companies, legal entities, and clients across this workspace.",
  "cowork.enterprise.companies.search": "Search companies...",
  "cowork.enterprise.companies.searchLabel": "Search companies",
  "cowork.enterprise.companies.trialLimit":
    "Your trial has reached its client company limit. Contact Andmera to upgrade and add more clients.",
  "cowork.enterprise.companies.total": "Total companies",
  "cowork.enterprise.companies.projects": "Projects across companies",
  "cowork.enterprise.companies.portfolio": "Company portfolio",
  "cowork.enterprise.companies.count": "{{count}} companies",
  "cowork.enterprise.companies.empty": "No companies match the current search.",
  "cowork.enterprise.companies.company": "Company / Entity",
  "cowork.enterprise.companies.country": "Country",
  "cowork.enterprise.companies.lastActivity": "Last activity",
  "cowork.enterprise.companies.noActivity": "No activity yet",
  "cowork.enterprise.companies.open": "Open",
  "cowork.enterprise.companies.add": "Add company",
  "cowork.enterprise.companies.create": "Create company",
  "cowork.enterprise.companies.namePlaceholder": "Company name",
  "cowork.enterprise.companies.countryPlaceholder": "Country",
  "cowork.enterprise.companies.registrationNumber": "Registration number",
  "cowork.enterprise.companies.vatNumber": "VAT number",
  "cowork.enterprise.companies.vatPlaceholder": "e.g. EE102288445",
  "cowork.enterprise.companies.registryHint": "Search or enter the details manually.",
  "cowork.enterprise.companies.registryLoading": "Searching the register...",
  "cowork.enterprise.companies.registryEmpty": "No matching companies. You can enter the details manually.",
  "cowork.enterprise.companies.registryUnavailable": "The register is unavailable. You can enter the details manually.",
  "cowork.enterprise.companies.registryDetailsLoading": "Loading company details...",
  "cowork.enterprise.companies.registryDetailsUnavailable":
    "Company details could not be loaded. Check the registration code and enter the VAT number manually.",
  "cowork.enterprise.companies.registryVatUnavailable":
    "No current VAT number was available. Enter it manually if needed.",
  "cowork.enterprise.companies.registrySuggestions": "Company suggestions",
  "cowork.enterprise.companies.registrySource": "Estonian e-Business Register",
  "cowork.enterprise.projects.description":
    "View entity-specific and cross-company business projects in the current scope.",
  "cowork.enterprise.projects.search": "Search projects...",
  "cowork.enterprise.projects.searchLabel": "Search projects",
  "cowork.enterprise.projects.portfolio": "Project portfolio",
  "cowork.enterprise.projects.count": "{{count}} projects",
  "cowork.enterprise.projects.empty": "No projects are available in the current scope.",
  "cowork.enterprise.projects.project": "Project",
  "cowork.enterprise.projects.noDescription": "No description provided",
  "cowork.enterprise.projects.add": "Add project",
  "cowork.enterprise.projects.create": "Create project",
  "cowork.enterprise.entity.loading": "Loading company...",
  "cowork.enterprise.entity.details": "Company details",
  "cowork.enterprise.entity.back": "Back to companies",
  "cowork.enterprise.entity.notFound": "This company was not found or is no longer accessible.",
  "cowork.enterprise.entity.loadError": "Company information could not be loaded. Please try again.",
  "cowork.enterprise.entity.company": "Company / Entity",
  "cowork.enterprise.entity.recentActivity": "Recent activity",
  "cowork.enterprise.entity.noActivity": "No recent activity for this company.",
  "cowork.enterprise.entity.attention": "Items requiring attention",
  "cowork.enterprise.entity.noAttention": "Nothing requires attention right now.",
  "cowork.enterprise.project.loading": "Loading project...",
  "cowork.enterprise.project.back": "Back to projects",
  "cowork.enterprise.project.notFound": "This project was not found or is no longer accessible.",
  "cowork.enterprise.project.loadError": "Project information could not be loaded. Please try again.",
  "cowork.enterprise.project.project": "Project",
  "cowork.enterprise.project.scope": "Scope: {{scope}}",
  "cowork.enterprise.project.entities": "entities",
  "cowork.enterprise.project.currentWorkflows": "Current workflows",
  "cowork.enterprise.project.openWorkflows": "Open the Workflows tab to manage this project's automations.",
  "cowork.enterprise.project.openActivity": "Open the Activity tab to review recent project events.",
  "cowork.enterprise.scope.navigation": "Scope navigation",
  "cowork.enterprise.scope.tab.overview": "Overview",
  "cowork.enterprise.scope.tab.employees": "Employees",
  "cowork.enterprise.scope.tab.settings": "Settings",
  "cowork.enterprise.companySettings.title": "Accounting profile",
  "cowork.enterprise.companySettings.editTitle": "Edit accounting profile",
  "cowork.enterprise.companySettings.loading": "Loading accounting profile...",
  "cowork.enterprise.companySettings.loadError": "The accounting profile could not be loaded. Please try again.",
  "cowork.enterprise.companySettings.saveError": "The accounting profile could not be saved. Please try again.",
  "cowork.enterprise.companySettings.notConfigured": "Not configured",
  "cowork.enterprise.companySettings.country": "Country",
  "cowork.enterprise.companySettings.currency": "Base currency",
  "cowork.enterprise.companySettings.fiscalStart": "Financial year start",
  "cowork.enterprise.companySettings.fiscalEnd": "Financial year end",
  "cowork.enterprise.companySettings.vatNumber": "VAT number",
  "cowork.enterprise.companySettings.vatReporting": "VAT reporting",
  "cowork.enterprise.companySettings.frequency.monthly": "Monthly",
  "cowork.enterprise.companySettings.frequency.quarterly": "Quarterly",
  "cowork.enterprise.companySettings.frequency.not_registered": "Not registered",
  "cowork.enterprise.companySettings.country.ee": "Estonia (EE)",
  "cowork.enterprise.companySettings.countryCodePlaceholder": "Country code, for example EE",
  "cowork.enterprise.companySettings.currencyCodePlaceholder": "Currency code, for example EUR",
  "cowork.enterprise.companySettings.select": "Select...",
  "cowork.enterprise.companySettings.month": "Month",
  "cowork.enterprise.companySettings.day": "Day",
  "cowork.enterprise.companySettings.error.country": "Select a valid country.",
  "cowork.enterprise.companySettings.error.currency": "Select a valid three-letter currency.",
  "cowork.enterprise.companySettings.error.fiscal": "Select a valid month and day.",
  "cowork.enterprise.companySettings.error.frequency": "Select a VAT reporting option.",
  "cowork.enterprise.companySettings.error.vat": "Enter a valid VAT number. For Estonia, use EE followed by 9 digits.",
  "cowork.enterprise.companySettings.confirmDescription":
    "Review these changes before overwriting the current accounting profile.",
  "cowork.enterprise.companySettings.confirmSave": "Confirm and save",
  "cowork.enterprise.companySettings.back": "Back",
  "cowork.enterprise.employees.title": "Employees",
  "cowork.enterprise.employees.description": "Manage employee details for this company.",
  "cowork.enterprise.employees.add": "Add employee",
  "cowork.enterprise.employees.edit": "Edit employee",
  "cowork.enterprise.employees.create": "Create employee",
  "cowork.enterprise.employees.actions": "Actions",
  "cowork.enterprise.employees.deleteTitle": "Delete employee",
  "cowork.enterprise.employees.deleteConfirm": "Delete {{name}}?",
  "cowork.enterprise.employees.deleteDescription":
    "This permanently removes the employee record from this company. It does not delete a login account.",
  "cowork.enterprise.employees.deleteError": "Employee could not be deleted. Please try again.",
  "cowork.enterprise.employees.firstName": "First name",
  "cowork.enterprise.employees.lastName": "Last name",
  "cowork.enterprise.employees.personalId": "Personal / national ID",
  "cowork.enterprise.employees.search": "Search employees",
  "cowork.enterprise.employees.downloadCsv": "Download visible employees as CSV",
  "cowork.enterprise.employees.empty": "No employees have been added to this company.",
  "cowork.enterprise.employees.noMatches": "No employees match your search.",
  "cowork.enterprise.employees.loadError": "Employees could not be loaded. Please try again.",
  "cowork.enterprise.employees.saveError": "Employee details could not be saved. Please try again.",
  "cowork.enterprise.employees.duplicateID": "An employee with this personal ID already exists in this company.",
  "cowork.enterprise.employees.denied": "You do not have permission to view or edit employees in this company.",
  "cowork.enterprise.employees.notFound": "The company or employee is no longer available. Reload and try again.",
  "cowork.enterprise.employees.invalidFields":
    "Enter a first name, last name and personal ID, using no more than 128 characters for each field.",
  "cowork.enterprise.scope.tab.projects": "Projects",
  "cowork.enterprise.scope.retry": "Try again",
  "cowork.enterprise.scope.loadError": "This section could not be loaded. Please try again.",
  "cowork.enterprise.scope.tab.data": "Data",
  "cowork.enterprise.scope.tab.files": "Files",
  "cowork.enterprise.scope.tab.knowledge": "Knowledge",
  "cowork.enterprise.scope.tab.periods": "Periods",
  "cowork.enterprise.scope.tab.reports": "Reports",
  "cowork.enterprise.scope.tab.agents": "Agents",
  "cowork.enterprise.scope.tab.workflows": "Workflows",
  "cowork.enterprise.scope.tab.activity": "Activity",
  "cowork.enterprise.knowledge.title": "Knowledge",
  "cowork.enterprise.knowledge.companyDescription":
    "Shared company reference documents for agents and workflows across projects.",
  "cowork.enterprise.knowledge.companyEmptyDescription":
    "Upload company reference documents or copy existing project-level files to share with the company.",
  "cowork.enterprise.knowledge.companyLinkHint":
    "Add a separate company-owned copy, shared with people who can access company Knowledge. The original project file remains untouched. Only files from projects you can edit are shown; workflow, period, and session files are excluded.",
  "cowork.enterprise.knowledge.companyFilesError": "Company files or source project permissions could not be loaded.",
  "cowork.enterprise.knowledge.companyNoFiles":
    "There are no available project-level files from editable projects in this company.",
  "cowork.enterprise.knowledge.companyDeleteDescription":
    'The company knowledge file "{{name}}" will be permanently deleted. Any original project file remains untouched.',
  "cowork.enterprise.knowledge.description": "Reusable project reference documents for agents and workflows.",
  "cowork.enterprise.knowledge.upload": "Upload files",
  "cowork.enterprise.knowledge.addExisting": "Add existing file",
  "cowork.enterprise.knowledge.emptyTitle": "No knowledge documents yet",
  "cowork.enterprise.knowledge.emptyDescription": "Upload reference documents or add existing project-level files.",
  "cowork.enterprise.knowledge.loadError": "Knowledge documents could not be loaded.",
  "cowork.enterprise.knowledge.filesError": "Project files could not be loaded.",
  "cowork.enterprise.knowledge.noFiles": "There are no available project-level files to add.",
  "cowork.enterprise.knowledge.uploading": "Uploading...",
  "cowork.enterprise.knowledge.uploadError": "The file could not be uploaded. Try again or remove it from this list.",
  "cowork.enterprise.knowledge.linkError": "The file could not be added to Knowledge. Please try again.",
  "cowork.enterprise.knowledge.downloadError": "The document could not be downloaded. Please try again.",
  "cowork.enterprise.knowledge.deleteError": "The knowledge file could not be deleted. Please try again.",
  "cowork.enterprise.knowledge.retry": "Try again",
  "cowork.enterprise.knowledge.removeUpload": "Remove",
  "cowork.enterprise.knowledge.size": "Size",
  "cowork.enterprise.knowledge.uploaded": "Uploaded",
  "cowork.enterprise.knowledge.download": "Download",
  "cowork.enterprise.knowledge.delete": "Delete knowledge file",
  "cowork.enterprise.knowledge.add": "Add",
  "cowork.enterprise.knowledge.linking": "Adding...",
  "cowork.enterprise.knowledge.close": "Close",
  "cowork.enterprise.knowledge.deleteTitle": "Delete knowledge file?",
  "cowork.enterprise.knowledge.deleteDescription":
    "{{name}} will be permanently deleted. This action cannot be undone.",
  "cowork.enterprise.knowledge.cancel": "Cancel",
  "cowork.enterprise.knowledge.confirmDelete": "Delete",
  "cowork.enterprise.knowledge.deleting": "Deleting...",
  "cowork.enterprise.scope.sectionDescription":
    "{{section}} for {{scope}} is connected to the new scoped navigation and will be populated in the next implementation phase.",
  "cowork.enterprise.section.readyTitle": "The new workspace is ready",
  "cowork.enterprise.section.readyDescription":
    "This area is connected to the new navigation and context model. Its business views will be added in the next implementation slice.",
  "cowork.enterprise.section.companies":
    "Manage the companies, legal entities, or clients available in this workspace.",
  "cowork.enterprise.section.projects": "View entity-specific, cross-company, and workspace-level projects.",
  "cowork.enterprise.section.files":
    "Find uploaded source files, generated files, and datasets across the current scope.",
  "cowork.enterprise.section.reports": "Open generated reports across the current business scope.",
  "cowork.enterprise.reportTemplates.description": "Explore the report templates available.",
  "cowork.enterprise.reportTemplates.filters": "Filters",
  "cowork.enterprise.reportTemplates.country": "Country",
  "cowork.enterprise.reportTemplates.reportType": "Report type",
  "cowork.enterprise.reportTemplates.accounting": "Accounting",
  "cowork.enterprise.reportTemplates.financial": "Financial",
  "cowork.enterprise.reportTemplates.management": "Management",
  "cowork.enterprise.reportTemplates.riskCompliance": "Risk & Compliance",
  "cowork.enterprise.reportTemplates.operations": "Operations",
  "cowork.enterprise.reportTemplates.all": "All reports",
  "cowork.enterprise.reportTemplates.allCountries": "All countries",
  "cowork.enterprise.reportTemplates.results": "Results: {{count}}",
  "cowork.enterprise.reportTemplates.comingSoon": "Coming soon",
  "cowork.enterprise.reportTemplates.sources": "Sources",
  "cowork.enterprise.reportTemplates.outputs": "Outputs",
  "cowork.enterprise.reportTemplates.tsd.sources": "Payroll · Bank statements · Employees",
  "cowork.enterprise.reportTemplates.kmd.sources": "Sales invoices · Purchase invoices · VAT records",
  "cowork.enterprise.reportTemplates.preview.cash-flow.title": "Cash Flow",
  "cowork.enterprise.reportTemplates.preview.cash-flow.description":
    "Understand operating, investing and financing cash movements.",
  "cowork.enterprise.reportTemplates.preview.cash-flow.sources": "Ledger · Bank data · Balance sheets",
  "cowork.enterprise.reportTemplates.preview.cash-flow.outputs": "Analysis · XLSX · PDF",
  "cowork.enterprise.reportTemplates.preview.budget-actual.title": "Budget vs Actual",
  "cowork.enterprise.reportTemplates.preview.budget-actual.description":
    "Compare actual results against approved budgets and investigate variances.",
  "cowork.enterprise.reportTemplates.preview.budget-actual.sources": "Budgets · Ledger · Cost centre mappings",
  "cowork.enterprise.reportTemplates.preview.budget-actual.outputs": "Variance analysis · XLSX",
  "cowork.enterprise.reportTemplates.preview.period-comparison.title": "Period Comparison",
  "cowork.enterprise.reportTemplates.preview.period-comparison.description":
    "Compare reporting periods and identify material movements.",
  "cowork.enterprise.reportTemplates.preview.period-comparison.sources": "Current and prior period data",
  "cowork.enterprise.reportTemplates.preview.period-comparison.outputs": "Analysis · XLSX",
  "cowork.enterprise.reportTemplates.preview.financial-ratios.title": "Financial Ratios",
  "cowork.enterprise.reportTemplates.preview.financial-ratios.description":
    "Calculate profitability, liquidity and leverage measures using defined rules.",
  "cowork.enterprise.reportTemplates.preview.financial-ratios.sources": "P&L · Balance sheet · Ratio definitions",
  "cowork.enterprise.reportTemplates.preview.financial-ratios.outputs": "Analysis · PDF",
  "cowork.enterprise.reportTemplates.preview.revenue-analysis.title": "Revenue Analysis",
  "cowork.enterprise.reportTemplates.preview.revenue-analysis.description":
    "Review revenue by customer, product, entity and period.",
  "cowork.enterprise.reportTemplates.preview.revenue-analysis.sources": "Sales ledger · CRM · Product data",
  "cowork.enterprise.reportTemplates.preview.revenue-analysis.outputs": "Analysis · XLSX",
  "cowork.enterprise.reportTemplates.preview.cost-analysis.title": "Cost Analysis",
  "cowork.enterprise.reportTemplates.preview.cost-analysis.description":
    "Explain cost movements by category, supplier and department.",
  "cowork.enterprise.reportTemplates.preview.cost-analysis.sources": "Expenses · Invoices · Cost centre mappings",
  "cowork.enterprise.reportTemplates.preview.cost-analysis.outputs": "Analysis · XLSX",
  "cowork.enterprise.reportTemplates.preview.working-capital.title": "Working Capital",
  "cowork.enterprise.reportTemplates.preview.working-capital.description":
    "Track receivables, payables and inventory through the operating cycle.",
  "cowork.enterprise.reportTemplates.preview.working-capital.sources": "AR/AP · Inventory · Ledger",
  "cowork.enterprise.reportTemplates.preview.working-capital.outputs": "Analysis · XLSX",
  "cowork.enterprise.reportTemplates.preview.management-report.title": "Management Report",
  "cowork.enterprise.reportTemplates.preview.management-report.description":
    "Validated financial data, operational KPIs and commentary in one reporting pack.",
  "cowork.enterprise.reportTemplates.preview.management-report.sources": "Financial reports · Operational KPIs",
  "cowork.enterprise.reportTemplates.preview.management-report.outputs": "Management pack · PDF · XLSX",
  "cowork.enterprise.reportTemplates.preview.ceo-report.title": "CEO Report",
  "cowork.enterprise.reportTemplates.preview.ceo-report.description":
    "An executive view of performance, material changes and exceptions.",
  "cowork.enterprise.reportTemplates.preview.ceo-report.sources": "Financial data · KPIs · Management context",
  "cowork.enterprise.reportTemplates.preview.ceo-report.outputs": "Executive report · PDF",
  "cowork.enterprise.reportTemplates.preview.board-report.title": "Board Report",
  "cowork.enterprise.reportTemplates.preview.board-report.description":
    "Financials, KPIs, risks and commentary with evidence behind material figures.",
  "cowork.enterprise.reportTemplates.preview.board-report.sources": "Financial reports · KPIs · Risk registers",
  "cowork.enterprise.reportTemplates.preview.board-report.outputs": "Board pack · PDF",
  "cowork.enterprise.reportTemplates.preview.company-performance.title": "Company Performance",
  "cowork.enterprise.reportTemplates.preview.company-performance.description":
    "Company results against agreed financial and operational measures.",
  "cowork.enterprise.reportTemplates.preview.company-performance.sources": "Accounting data · Operational systems",
  "cowork.enterprise.reportTemplates.preview.company-performance.outputs": "Performance report · PDF",
  "cowork.enterprise.reportTemplates.preview.group-performance.title": "Group Performance",
  "cowork.enterprise.reportTemplates.preview.group-performance.description":
    "Compare entity performance using aligned periods and reporting mappings.",
  "cowork.enterprise.reportTemplates.preview.group-performance.sources": "Entity reports · Group mappings",
  "cowork.enterprise.reportTemplates.preview.group-performance.outputs": "Group report · XLSX",
  "cowork.enterprise.reportTemplates.preview.kpi-reporting.title": "KPI Reporting",
  "cowork.enterprise.reportTemplates.preview.kpi-reporting.description":
    "Repeatable metrics with explicit definitions and source-level drill-down.",
  "cowork.enterprise.reportTemplates.preview.kpi-reporting.sources": "CRM · ERP · KPI definitions",
  "cowork.enterprise.reportTemplates.preview.kpi-reporting.outputs": "KPI report · XLSX",
  "cowork.enterprise.reportTemplates.preview.exception-report.title": "Exception Report",
  "cowork.enterprise.reportTemplates.preview.exception-report.description":
    "Prioritize unresolved differences and missing evidence for investigation.",
  "cowork.enterprise.reportTemplates.preview.exception-report.sources": "Validation results · Reconciliations",
  "cowork.enterprise.reportTemplates.preview.exception-report.outputs": "Exception list · Evidence links",
  "cowork.enterprise.reportTemplates.preview.data-quality.title": "Data Quality Report",
  "cowork.enterprise.reportTemplates.preview.data-quality.description":
    "Review completeness, duplicates, invalid mappings and inconsistent records.",
  "cowork.enterprise.reportTemplates.preview.data-quality.sources": "Source datasets · Quality rules",
  "cowork.enterprise.reportTemplates.preview.data-quality.outputs": "Quality report · XLSX",
  "cowork.enterprise.reportTemplates.preview.audit-readiness.title": "Audit Readiness",
  "cowork.enterprise.reportTemplates.preview.audit-readiness.description":
    "Assemble reporting evidence, control results and reviewer decisions.",
  "cowork.enterprise.reportTemplates.preview.audit-readiness.sources": "Reports · Source evidence · Review records",
  "cowork.enterprise.reportTemplates.preview.audit-readiness.outputs": "Audit evidence pack · PDF",
  "cowork.enterprise.reportTemplates.preview.control-reconciliation.title": "Control & Reconciliation",
  "cowork.enterprise.reportTemplates.preview.control-reconciliation.description":
    "Keep balance checks and reconciliation results attached to the reporting period.",
  "cowork.enterprise.reportTemplates.preview.control-reconciliation.sources": "Ledger · Source totals · Control definitions",
  "cowork.enterprise.reportTemplates.preview.control-reconciliation.outputs": "Control report · XLSX",
  "cowork.enterprise.reportTemplates.preview.procurement.title": "Procurement Reporting",
  "cowork.enterprise.reportTemplates.preview.procurement.description":
    "A custom workflow for supplier spend, purchasing trends and exceptions.",
  "cowork.enterprise.reportTemplates.preview.procurement.sources": "Purchase orders · Invoices · Supplier records",
  "cowork.enterprise.reportTemplates.preview.procurement.outputs": "Dashboard · XLSX",
  "cowork.enterprise.reportTemplates.preview.project-performance.title": "Project Performance",
  "cowork.enterprise.reportTemplates.preview.project-performance.description":
    "Project costs, milestones and performance measures configured around your rules.",
  "cowork.enterprise.reportTemplates.preview.project-performance.sources": "Project records · Budgets · Costs",
  "cowork.enterprise.reportTemplates.preview.project-performance.outputs": "Dashboard · XLSX",
  "cowork.enterprise.reportTemplates.preview.customer-analysis.title": "Customer Analysis",
  "cowork.enterprise.reportTemplates.preview.customer-analysis.description":
    "Customer-specific reporting from sales, service and accounting data.",
  "cowork.enterprise.reportTemplates.preview.customer-analysis.sources": "CRM · Sales · Accounting exports",
  "cowork.enterprise.reportTemplates.preview.customer-analysis.outputs": "Dashboard · XLSX",
  "cowork.enterprise.reportTemplates.general": "General",
  "cowork.enterprise.reportTemplates.filterHint": "Select a country to show only its country-specific templates.",
  "cowork.enterprise.reportTemplates.empty": "No templates match the selected filters.",
  "cowork.enterprise.reportTemplates.launch.generateLabel": "Generate {{template}} in a new chat",
  "cowork.enterprise.reportTemplates.launch.selectProject":
    "Select a project in the top bar to generate a report in a new chat.",
  "cowork.enterprise.reportTemplates.launch.selectPeriod":
    "Select a valid reporting period or All periods in the top bar before generating a report.",
  "cowork.enterprise.reportTemplates.launch.scope": "New chat scope: {{project}} / {{period}}",
  "cowork.enterprise.reportTemplates.launch.starting": "Starting a new chat for {{template}}...",
  "cowork.enterprise.reportTemplates.launch.configuration": "Could not load the agent settings. Please try again.",
  "cowork.enterprise.reportTemplates.launch.checkChats":
    "Could not confirm whether the chat was created. Check Chats for {{title}} before generating again. The report request has not been sent.",
  "cowork.enterprise.reportTemplates.launch.openFailed":
    "The chat {{title}} was created, but could not be opened. Retry will use this same chat.",
  "cowork.enterprise.reportTemplates.launch.scopeChanged":
    "The selected scope changed. Generate again to start a new chat in the current scope.",
  "cowork.enterprise.reportTemplates.launch.createdNotSent":
    "The selected scope changed. The chat {{title}} was saved in its original project, but the report request was not sent. You can find it in Chats.",
  "cowork.enterprise.reportTemplates.launch.viewChats": "View Chats",
  "cowork.enterprise.section.dataSources": "Manage configured customer data connections and their company scope.",
  "cowork.enterprise.section.agents": "Manage the AI agents assigned to your workspace, companies, and projects.",
  "cowork.enterprise.section.agentLibrary": "Browse available agents and add them to the appropriate business scope.",
  "cowork.enterprise.agents.description": "Create and manage agents assigned to the selected project.",
  "cowork.enterprise.agents.workspaceDescription": "Manage workspace-owned agents and control where they can operate.",
  "cowork.enterprise.agents.browseLibrary": "Browse Agent Library",
  "cowork.enterprise.agents.empty": "No agents in this scope",
  "cowork.enterprise.agents.emptyDescription":
    "Add an agent from the library, then assign it to the workspace, companies, or projects.",
  "cowork.enterprise.agents.noPurpose": "No purpose has been provided for this agent.",
  "cowork.enterprise.agents.notAssigned": "Not assigned",
  "cowork.enterprise.agents.editScope": "Edit scope",
  "cowork.enterprise.agents.scope.workspace": "All Companies",
  "cowork.enterprise.agents.scope.entity": "Selected Companies",
  "cowork.enterprise.agents.scope.project": "Selected Projects",
  "cowork.enterprise.agents.selectedEntity": "Selected company",
  "cowork.enterprise.agents.selectedProject": "Selected project",
  "cowork.enterprise.agents.workspaceLibraryDescription":
    "Add reusable agents to the workspace, then configure where each agent can operate.",
  "cowork.enterprise.agents.workspaceOwned": "Workspace agent",
  "cowork.enterprise.agents.addToWorkspace": "Add to Workspace",
  "cowork.enterprise.agents.agent": "Agent",
  "cowork.enterprise.agents.selectProject": "Select a project to manage its agents",
  "cowork.enterprise.agents.selectProjectDescription":
    "Choose a project from the top bar. Agent configuration and permissions are scoped to that project.",
  "cowork.enterprise.agents.libraryDescription": "Browse reusable agent templates and add them to a project.",
  "cowork.enterprise.agents.addingTo": "Adding agents to {{project}}",
  "cowork.enterprise.agents.projectRequired": "Select a project first",
  "cowork.enterprise.agents.add": "Add agent",
  "cowork.enterprise.agents.added": "Added",
  "cowork.enterprise.agents.viewMyAgents": "View My Agents",
  "cowork.enterprise.section.workflows": "Monitor business automations, their scope, status, and recent runs.",
  "cowork.enterprise.workflows.description": "Create and monitor report generation process",
  "cowork.enterprise.workflows.search": "Search workflows...",
  "cowork.enterprise.workflows.create": "Create workflow",
  "cowork.enterprise.workflows.selectProjectToCreate": "Select a project before creating a workflow.",
  "cowork.enterprise.workflows.name": "Workflow name",
  "cowork.enterprise.workflows.namePlaceholder": "Monthly management reporting",
  "cowork.enterprise.workflows.empty": "No workflows are available in the current scope.",
  "cowork.enterprise.workflows.workflow": "Workflow",
  "cowork.enterprise.workflows.runs": "Runs",
  "cowork.enterprise.workflows.lastRun": "Last run",
  "cowork.enterprise.workflows.lastResult": "Last result",
  "cowork.enterprise.workflows.never": "Never run",
  "cowork.enterprise.workflows.run": "Run",
  "cowork.enterprise.workflows.running": "Running...",
  "cowork.enterprise.workflows.disable": "Disable",
  "cowork.enterprise.workflows.enable": "Enable",
  "cowork.enterprise.workflows.back": "Back to workflows",
  "cowork.enterprise.workflows.data.refresh": "Refresh data",
  "cowork.enterprise.workflows.data.loadFailed": "Could not load this workflow's data.",
  "cowork.enterprise.workflows.data.updateFailed": "Could not update this workflow's data.",
  "cowork.enterprise.workflows.data.noRun": "Generate a run to view its results.",
  "cowork.enterprise.workflows.data.period": "Period workflow",
  "cowork.enterprise.workflows.data.saved": "Saved workflow data",
  "cowork.enterprise.workflows.data.open": "View data",
  "cowork.enterprise.workflows.scopeDescription": "{{company}} / {{project}}",
  "cowork.enterprise.workflows.agent": "Assigned agent",
  "cowork.enterprise.workflows.workspaceDefaultAgent": "Workspace default agent",
  "cowork.enterprise.workflows.purpose": "Purpose and expected outcome",
  "cowork.enterprise.workflows.steps": "Workflow steps",
  "cowork.enterprise.workflows.inputs": "Inputs",
  "cowork.enterprise.workflows.outputs": "Outputs",
  "cowork.enterprise.workflows.approvals": "Approval",
  "cowork.enterprise.workflows.approvalRequired": "Require approval before final delivery",
  "cowork.enterprise.workflows.required": "Required",
  "cowork.enterprise.workflows.notRequired": "Not required",
  "cowork.enterprise.workflows.tab.overview": "Overview",
  "cowork.enterprise.workflows.tab.runs": "Runs",
  "cowork.enterprise.workflows.tab.data": "Data",
  "cowork.enterprise.workflows.tab.reports": "Reports",
  "cowork.enterprise.workflows.tab.approvals": "Approvals",
  "cowork.enterprise.workflows.started": "Started",
  "cowork.enterprise.workflows.validation": "Validation",
  "cowork.enterprise.workflows.exceptions": "Exceptions",
  "cowork.enterprise.workflows.openChat": "Open chat",
  "cowork.enterprise.workflows.noRuns": "This workflow has not been run yet.",
  "cowork.enterprise.workflows.noApprovals": "No approval requests are related to this workflow.",
  "cowork.enterprise.workflows.status.created": "Created",
  "cowork.enterprise.workflows.status.running": "Running",
  "cowork.enterprise.workflows.status.completed": "Completed",
  "cowork.enterprise.workflows.status.needsReview": "Needs review",
  "cowork.enterprise.workflows.status.failed": "Failed",
  "cowork.enterprise.workflows.step.load_data": "Load data",
  "cowork.enterprise.workflows.step.loadData": "Load Data",
  "cowork.enterprise.workflows.step.validate": "Validate",
  "cowork.enterprise.workflows.step.analyze": "Analyze",
  "cowork.enterprise.workflows.step.generate_report": "Generate report",
  "cowork.enterprise.workflows.step.generateReport": "Generate Report",
  "cowork.enterprise.workflows.step.approval": "Send for Approval",
  "cowork.enterprise.workflows.step.deliver": "Deliver",
  "cowork.enterprise.workflows.input.files": "Uploaded files",
  "cowork.enterprise.workflows.input.connected_sources": "Connected sources",
  "cowork.enterprise.workflows.input.trial_balance": "Trial balance",
  "cowork.enterprise.workflows.input.bank_statements": "Bank statements",
  "cowork.enterprise.workflows.input.ar_ap_open_items": "AR/AP open items",
  "cowork.enterprise.workflows.input.general_ledger": "General ledger",
  "cowork.enterprise.workflows.output.report": "Report",
  "cowork.enterprise.workflows.output.dashboard": "Dashboard",
  "cowork.enterprise.workflows.output.exception_list": "Exception list",
  "cowork.enterprise.workflows.output.approval_package": "Approval package",
  "cowork.enterprise.section.approvals": "Review pending reports, decisions, and generated outputs in one queue.",
  "cowork.enterprise.approvals.description":
    "Track report review requests, reviewer decisions, and items waiting for attention.",
  "cowork.enterprise.approvals.total": "Total requests",
  "cowork.enterprise.approvals.pending": "Pending",
  "cowork.enterprise.approvals.requested": "Pending",
  "cowork.enterprise.approvals.approved": "Approved",
  "cowork.enterprise.approvals.rejected": "Rejected",
  "cowork.enterprise.approvals.search": "Search approvals...",
  "cowork.enterprise.approvals.statusFilter": "Filter approvals by status",
  "cowork.enterprise.approvals.allStatuses": "All statuses",
  "cowork.enterprise.approvals.empty": "No approval requests found.",
  "cowork.enterprise.approvals.report": "Report",
  "cowork.enterprise.approvals.reviewer": "Reviewer",
  "cowork.enterprise.approvals.requestedAt": "Requested",
  "cowork.enterprise.approvals.updatedAt": "Last updated",
  "cowork.enterprise.approvals.openReview": "Open review",
  "cowork.enterprise.approvals.details": "Approval details",
  "cowork.enterprise.approvals.viewDetails": "View approval details for {{report}}",
  "cowork.enterprise.approvals.conversationDescription": "Read the reviewer's feedback and reply as yourself.",
  "cowork.enterprise.approvals.readOnly": "You have view-only access to this conversation.",
  "cowork.enterprise.approvals.editReviewer": "Edit reviewer",
  "cowork.enterprise.approvals.deleteTitle": "Delete approval request",
  "cowork.enterprise.approvals.deleteDescription": "Delete the approval request for {{report}}?",
  "cowork.enterprise.section.activity":
    "Follow business-friendly activity across companies, projects, agents, and workflows.",
  "cowork.enterprise.section.integrations": "Browse connector capabilities and manage connected business systems.",
  "cowork.enterprise.integrations.category.businessSystems": "Business Systems",
  "cowork.enterprise.integrations.category.data": "Data",
  "cowork.enterprise.integrations.category.productivity": "Productivity",
  "cowork.enterprise.integrations.category.collaboration": "Collaboration",
  "cowork.enterprise.integrations.category.files": "Files & Storage",
  "cowork.enterprise.dataSources.description":
    "Configured workspace data connections that agents can use as governed source context.",
  "cowork.enterprise.dataSources.empty": "No data sources are connected yet. Open Integrations to connect one.",
  "cowork.enterprise.dataSources.name": "Data source",
  "cowork.enterprise.dataSources.connection": "Connection",
  "cowork.enterprise.section.auditLog": "Inspect detailed audit events separately from the business activity feed.",
  "cowork.enterprise.activity.title": "Activity",
  "cowork.enterprise.activity.description":
    "Follow business activity across the selected company, project, agents, workflows, files, and reports.",
  "cowork.enterprise.activity.search": "Search activity...",
  "cowork.enterprise.activity.actionType": "Action type",
  "cowork.enterprise.activity.empty": "No activity matches the current filters.",
  "cowork.enterprise.activity.category.all": "All activity",
  "cowork.enterprise.activity.category.files": "Files",
  "cowork.enterprise.activity.category.reports": "Reports",
  "cowork.enterprise.activity.category.workflows": "Workflows",
  "cowork.enterprise.activity.category.approvals": "Approvals",
  "cowork.enterprise.activity.category.agents": "Agents and chats",
  "cowork.enterprise.activity.category.integrations": "Integrations",
  "cowork.enterprise.activity.category.projects": "Projects",
  "cowork.enterprise.activity.dateRange": "Date range",
  "cowork.enterprise.activity.date.all": "All time",
  "cowork.enterprise.activity.date.today": "Today",
  "cowork.enterprise.activity.date.7d": "Last 7 days",
  "cowork.enterprise.activity.date.30d": "Last 30 days",
  "cowork.enterprise.activity.event.file": "File activity: {{name}}",
  "cowork.enterprise.activity.event.report": "Report activity: {{name}}",
  "cowork.enterprise.activity.event.approval": "Approval activity: {{name}}",
  "cowork.enterprise.audit.title": "Audit Log",
  "cowork.enterprise.audit.description":
    "Review detailed system events, actors, identifiers, and payloads for compliance and troubleshooting.",
  "cowork.enterprise.audit.search": "Search audit events...",
  "cowork.enterprise.audit.eventType": "Event type",
  "cowork.enterprise.audit.allEvents": "All event types",
  "cowork.enterprise.audit.actor": "Actor",
  "cowork.enterprise.audit.allActors": "All actors",
  "cowork.enterprise.audit.event": "Event",
  "cowork.enterprise.audit.date": "Date",
  "cowork.enterprise.audit.system": "System",
  "cowork.enterprise.audit.empty": "No audit events match the current filters.",
  "cowork.enterprise.audit.loadedCount": "Loaded events: {{count}}",
  "cowork.enterprise.audit.loadedHint": "Filters apply to loaded events. Load more to search older entries.",
  "cowork.enterprise.audit.loadError": "Audit events could not be loaded. Please try again.",
  "cowork.enterprise.audit.viewDetails": "View details",
  "cowork.enterprise.audit.hideDetails": "Hide details",
  "cowork.enterprise.audit.eventId": "Event ID",
  "cowork.enterprise.audit.payload": "Payload",
  "cowork.enterprise.section.settings":
    "Configure workspace terminology, access, defaults, and enterprise preferences.",
  "cowork.enterprise.settings.description": "Manage application appearance and behavior.",
  "cowork.projects.title": "Projects",
  "cowork.projects.placeholder": "Project name",
  "cowork.project.name": "Project name",
  "cowork.project.type": "Project type",
  "cowork.project.type.workflow": "Workflow",
  "cowork.project.type.periodical": "Periodical",
  "cowork.project.workOrganization": "Work organization",
  "cowork.project.workOrganization.workflow": "Workflow style",
  "cowork.project.workOrganization.periodical": "Periodical",
  "cowork.project.firstPeriod": "First period",
  "cowork.project.firstPeriodPlaceholder": "e.g. January 2026",
  "cowork.project.accountingSetup.title": "Accounting setup",
  "cowork.project.periodSetup.title": "Period setup",
  "cowork.project.accountingSetup.description":
    "We will provision the Accounting Coworker, default accounting period, and initial settings. You can refine connections after creation.",
  "cowork.project.periodSetup.description":
    "We will create an initial period and show period-driven navigation. You can add more periods later.",
  "cowork.project.accountingSetup.system": "Accounting system: 1C",
  "cowork.project.accountingSetup.chart": "Chart of accounts: import/connect",
  "cowork.project.accountingSetup.vat": "VAT registered: Yes",
  "cowork.project.accountingSetup.bank": "Bank account",
  "cowork.project.accountingSetup.currency": "Base currency: EUR",
  "cowork.project.createTitle": "Create project",
  "cowork.project.editPrompt": "Project name",
  "cowork.project.deleteTitle": "Delete project",
  "cowork.project.deleteConfirm": "Delete project {{name}}?",
  "cowork.project.deleteDescription": "This removes the project from your Andmera report automation workspace.",
  "cowork.company.deleteTitle": "Delete company",
  "cowork.company.deleteConfirm": "Delete company {{name}}?",
  "cowork.company.deleteDescription": "This removes the company and its projects from the workspace.",
  "cowork.report.deleteTitle": "Delete report",
  "cowork.report.deleteConfirm": "Delete report {{name}}?",
  "cowork.report.deleteDescription": "This report will no longer be available to workspace members.",
  "cowork.profile.signedIn": "Signed in",
  "cowork.profile.logout": "Log out",
  "cowork.profile.logoutTitle": "Log out",
  "cowork.profile.logoutConfirm": "Log out {{user}}?",
  "cowork.profile.logoutDescription": "You will need to sign in again to access your report automation workspace.",
  "cowork.activity.menu": "Activity logs",
  "cowork.activity.title": "Activity logs",
  "cowork.activity.search": "Search activity, messages, sessions, files, and audit events",
  "cowork.activity.refresh": "Refresh",
  "cowork.activity.filter.all": "All activity",
  "cowork.activity.filter.audit": "Audit events",
  "cowork.activity.filter.message": "Chat messages",
  "cowork.activity.count": "{{count}} activity items",
  "cowork.activity.empty": "No activity found.",
  "cowork.usage.menu": "Usage",
  "cowork.usage.title": "Usage",
  "cowork.usage.workspaceDescription": "Track workspace seats and trial limits.",
  "cowork.usage.loadError": "Unable to load workspace usage.",
  "cowork.usage.allowances": "Plan limits",
  "cowork.usage.companies": "Client companies",
  "cowork.usage.storage": "File storage (MB)",
  "cowork.usage.agentRequests": "Agent requests",
  "cowork.usage.quota": "{{used}} of {{limit}} used",
  "cowork.usage.modelTitle": "Andmera model usage",
  "cowork.usage.lastUpdated": "Last updated {{value}}",
  "cowork.usage.projects": "Projects",
  "cowork.usage.workflows": "Workflows",
  "cowork.usage.chats": "Chats",
  "cowork.usage.files": "Source files",
  "cowork.usage.extractions": "Extractions",
  "cowork.usage.transformations": "Transformations",
  "cowork.usage.outputTables": "Output tables",
  "cowork.usage.reports": "Reports",
  "cowork.usage.approvals": "Approvals",
  "cowork.usage.inputTokens": "Input tokens",
  "cowork.usage.outputTokens": "Output tokens",
  "cowork.usage.totalTokens": "Total tokens",
  "cowork.usage.estimatedCost": "Estimated cost",
  "cowork.usage.efficiencyTitle": "Efficiency",
  "cowork.usage.successRate": "Success rate",
  "cowork.usage.failedRuns": "Failed runs",
  "cowork.usage.avgTokensPerChat": "Avg tokens per chat",
  "cowork.usage.avgCostPerChat": "Avg cost per chat",
  "cowork.usage.avgResponseSeconds": "Avg response time",
  "cowork.usage.timeSaved": "Estimated time saved",
  "cowork.usage.fileStatsTitle": "File processing",
  "cowork.usage.images": "Images",
  "cowork.usage.pdfs": "PDFs",
  "cowork.usage.spreadsheets": "Spreadsheets",
  "cowork.usage.documents": "Documents",
  "cowork.usage.previewableFiles": "Previewable files",
  "cowork.usage.filesWithoutPreview": "Files without preview",
  "cowork.usage.byProjectTitle": "Usage by project",
  "cowork.usage.byWorkflowTitle": "Usage by workflow",
  "cowork.usage.recentRunsTitle": "Recent runs",
  "cowork.usage.recentActivityTitle": "Recent activity",
  "cowork.usage.trustTitle": "Trust and data sources",
  "cowork.usage.project": "Project",
  "cowork.usage.workflow": "Workflow",
  "cowork.usage.time": "Time",
  "cowork.usage.prompt": "Prompt",
  "cowork.usage.status": "Status",
  "cowork.usage.duration": "Duration",
  "cowork.usage.emptyTable": "No usage details yet.",
  "cowork.navigation.collapse": "Collapse navigation",
  "cowork.navigation.expand": "Expand navigation",
  "cowork.navigation.files": "Files",
  "cowork.navigation.toggle": "Toggle navigation",
  "cowork.navigation.resize": "Resize navigation",
  "cowork.agents.title": "Agents",
  "cowork.agents.description":
    "Create project-specific agents with instructions, tools, integrations, and permissions.",
  "cowork.agents.add": "Add agent",
  "cowork.agents.addShort": "Add",
  "cowork.agents.create": "Create agent",
  "cowork.agents.createTitle": "Create agent",
  "cowork.agents.draft.name": "New Agent",
  "cowork.agents.draft.description": "Configure this agent before using it in a workflow.",
  "cowork.agents.draft.instructions": "Describe what this agent should do, when it should be used, and which outputs it should produce.",
  "cowork.agents.editTitle": "Edit agent",
  "cowork.agents.empty": "Select a project to manage agents, or create an agent when a project is available.",
  "cowork.agents.emptyCompact": "Select a project to manage agents.",
  "cowork.agents.default": "Default",
  "cowork.agents.defaultShort": "Default",
  "cowork.agents.builtIn": "Built-in",
  "cowork.agents.enabled": "Enabled",
  "cowork.agents.disabled": "Disabled",
  "cowork.agents.enable": "Enable",
  "cowork.agents.disable": "Disable",
  "cowork.agents.setDefault": "Set default",
  "cowork.agents.template": "Template",
  "cowork.agents.name": "Agent name",
  "cowork.agents.shortDescription": "Short description",
  "cowork.agents.mode": "Mode",
  "cowork.agents.mode.primary": "Primary",
  "cowork.agents.mode.subagent": "Subagent",
  "cowork.agents.mode.all": "Primary and subagent",
  "cowork.agents.instructions": "Instructions",
  "cowork.agents.tools": "Tools",
  "cowork.agents.integrations": "Integrations",
  "cowork.agents.permissions": "Permissions",
  "cowork.agents.foundation": "Foundation agent",
  "cowork.agents.noDescription": "No description provided.",
  "cowork.agents.noInstructions": "No instructions provided.",
  "cowork.agents.noneEnabled": "None enabled.",
  "cowork.agents.tool.readFiles": "Read project files",
  "cowork.agents.tool.generateReports": "Generate reports",
  "cowork.agents.tool.webSearch": "Web search",
  "cowork.agents.tool.approvalWorkflow": "Approval workflow",
  "cowork.agents.tool.integrations": "Use integrations",
  "cowork.agents.tool.calculations": "Run calculations",
  "cowork.agents.permission.read": "Read files",
  "cowork.agents.permission.edit": "Edit/write files",
  "cowork.agents.permission.websearch": "Web search",
  "cowork.agents.permission.webfetch": "Web fetch",
  "cowork.agents.permission.bash": "Shell/code execution",
  "cowork.agents.permission.skill": "Skills",
  "cowork.agents.permission.allow": "Allow",
  "cowork.agents.permission.ask": "Ask",
  "cowork.agents.permission.deny": "Deny",
  "cowork.agents.template.customReport": "Custom Report Agent",
  "cowork.agents.template.customReport.description":
    "Extracts facts, validates inputs, and drafts custom reports from project documents.",
  "cowork.agents.template.customReport.instructions":
    "You are a Andmera Custom Report Agent. Help users build compliance, risk, audit, and management reports from project documents. Extract relevant facts, validate inputs, identify missing information, cite available sources, and draft clear report outputs with assumptions and open issues.",
  "cowork.agents.template.onboarding": "Corporate Onboarding Agent",
  "cowork.agents.template.onboarding.description":
    "Orchestrates corporate onboarding workflows across KYC documents, checks, approvals, and audit trail.",
  "cowork.agents.template.onboarding.instructions":
    "You are a Andmera Corporate Onboarding Agent for banking operations. Process onboarding requests by extracting company facts, validating KYC completeness, checking risk and sanctions requirements, requesting missing data, preparing approval packages, proposing system updates, and summarizing the audit trail. Do not claim real banking-system updates unless a tool confirms them.",
  "cowork.agents.template.extraction": "Data Extraction Agent",
  "cowork.agents.template.extraction.description":
    "Extracts structured tables and fields from uploaded files for downstream workflows.",
  "cowork.agents.template.extraction.instructions":
    "You are a Andmera Data Extraction Agent. Inspect uploaded project files, identify tables and key fields, normalize extracted data, preserve source context, flag low-confidence values, and produce structured outputs suitable for report generation and validation.",
  "cowork.agents.template.accounting": "Accounting Agent",
  "cowork.agents.template.accounting.description":
    "Processes accountant source packs, invoices, payments, ledger drafts, KMD/TSD tax reports, and review blockers.",
  "cowork.agents.template.accounting.instructions":
    "You are a Andmera Accounting Agent. Run agent-driven accounting workflows for accountant clients. Inspect uploaded source packs, classify documents, extract invoice/payment facts, match payments, propose postings, prepare KMD/TSD drafts, save structured accounting results through Andmera helper commands, and create review blockers for accountant decisions. Do not approve, submit, or mark external filing complete without explicit accountant instruction.",
  "cowork.integrations.google-drive": "Google Drive",
  "cowork.integrations.one-drive": "OneDrive",
  "cowork.integrations.sharepoint-online": "SharePoint",
  "cowork.integrations.slack": "Slack",
  "cowork.integrations.microsoft-teams": "Microsoft Teams",
  "cowork.integrations.salesforce": "Salesforce",
  "cowork.workflow.label": "Workflow",
  "cowork.workflow.create": "Add workflow",
  "cowork.workflow.empty": "No workflows yet.",
  "cowork.workflow.createTitle": "Create workflow",
  "cowork.workflow.name": "Workflow name",
  "cowork.workflow.namePlaceholder": "e.g. Q4 board report, Vendor audit, Monthly risk summary",
  "cowork.workflow.type": "Workflow type",
  "cowork.workflow.type.workflow": "Workflow",
  "cowork.workflow.type.periodical": "Periodical",
  "cowork.period.create": "Add period",
  "cowork.period.empty": "No periods yet.",
  "cowork.period.createTitle": "Create period",
  "cowork.period.name": "Period name",
  "cowork.period.namePlaceholder": "e.g. January 2026",
  "cowork.period.type": "Period type",
  "cowork.period.type.monthly": "Monthly",
  "cowork.period.type.quarterly": "Quarterly",
  "cowork.period.type.yearly": "Yearly",
  "cowork.period.select": "Select period",
  "cowork.period.year": "Select year",
  "cowork.period.q1": "Q1",
  "cowork.period.q2": "Q2",
  "cowork.period.q3": "Q3",
  "cowork.period.q4": "Q4",
  "cowork.period.fullYear": "Full year",
  "cowork.period.month.january": "January",
  "cowork.period.month.february": "February",
  "cowork.period.month.march": "March",
  "cowork.period.month.april": "April",
  "cowork.period.month.may": "May",
  "cowork.period.month.june": "June",
  "cowork.period.month.july": "July",
  "cowork.period.month.august": "August",
  "cowork.period.month.september": "September",
  "cowork.period.month.october": "October",
  "cowork.period.month.november": "November",
  "cowork.period.month.december": "December",
  "cowork.accounting.label": "Accounting",
  "cowork.reports.tab": "Reports",
  "cowork.accounting.title": "Accounting workspace",
  "cowork.accounting.description":
    "Review accounting documents, payment matches, ledger drafts, tax reports, and EMTA submission packages for this workflow.",
  "cowork.accounting.table.downloadCsv": "Download table as CSV",
  "cowork.table.expand": "Expand table",
  "cowork.table.preview": "Table preview",
  "cowork.accounting.client.title": "Client accounting profile",
  "cowork.accounting.client.description": "The accountant is working on this client and selected accounting period.",
  "cowork.accounting.client.client": "Client",
  "cowork.accounting.client.period": "Accounting period",
  "cowork.accounting.client.registrationCode": "Registration code",
  "cowork.accounting.client.vatNumber": "VAT number",
  "cowork.accounting.client.address": "Address",
  "cowork.accounting.client.country": "Country",
  "cowork.accounting.placeholder": "Foundation placeholder. Document processing comes next.",
  "cowork.accounting.workflow.title": "Accounting workflow",
  "cowork.accounting.workflow.description":
    "From document upload to reviewed postings, exports, tax reports, and submission status.",
  "cowork.accounting.workflow.step.upload.title": "Upload files",
  "cowork.accounting.workflow.step.upload.description": "Invoices, receipts, bank statements, and accounting exports.",
  "cowork.accounting.workflow.step.extract.title": "Extract fields",
  "cowork.accounting.workflow.step.extract.description": "Recognize document facts, VAT, totals, and due dates.",
  "cowork.accounting.workflow.step.findPayment.title": "Find payments",
  "cowork.accounting.workflow.step.findPayment.description": "Import or locate bank transactions for documents.",
  "cowork.accounting.workflow.step.match.title": "Match",
  "cowork.accounting.workflow.step.match.description": "Compare amount, currency, reference, counterparty, and date.",
  "cowork.accounting.workflow.step.classify.title": "Classify",
  "cowork.accounting.workflow.step.classify.description": "Suggest category, account, VAT treatment, and confidence.",
  "cowork.accounting.workflow.step.postings.title": "Postings",
  "cowork.accounting.workflow.step.postings.description": "Generate balanced debit and credit suggestions.",
  "cowork.accounting.workflow.step.review.title": "Review",
  "cowork.accounting.workflow.step.review.description": "Accountant approves, edits, or rejects recommendations.",
  "cowork.accounting.workflow.step.export.title": "Export",
  "cowork.accounting.workflow.step.export.description": "Create validated CSV, XLSX, XML, JSON, PDF, or ZIP packages.",
  "cowork.accounting.workflow.step.tax.title": "Tax drafts",
  "cowork.accounting.workflow.step.tax.description": "Prepare and validate KMD/TSD drafts.",
  "cowork.accounting.workflow.step.submit.title": "Submit/status",
  "cowork.accounting.workflow.step.submit.description": "Track manual or direct submission status and receipts.",
  "cowork.accounting.workflow.step.correct.title": "Correct",
  "cowork.accounting.workflow.step.correct.description": "Fix rejected reports and resubmit when needed.",
  "cowork.accounting.summary.documents": "Documents in processing",
  "cowork.accounting.summary.payments": "Payments found",
  "cowork.accounting.summary.confidence": "Average confidence",
  "cowork.accounting.summary.attention": "Need confirmation",
  "cowork.accounting.filter.placeholder": "Filter this accounting view",
  "cowork.accounting.documents.title": "Documents",
  "cowork.progress.reading": "Reading information",
  "cowork.progress.extracting": "Extracting data",
  "cowork.progress.checking": "Checking data",
  "cowork.progress.calculating": "Calculating results",
  "cowork.progress.generating": "Preparing results",
  "cowork.progress.saving": "Saving results",
  "cowork.progress.document": "Document",
  "cowork.progress.table": "Table",
  "cowork.progress.dataset": "Dataset",
  "cowork.progress.report": "Report",
  "cowork.progress.namedDocument": "Document: {{name}}",
  "cowork.progress.namedTable": "Table: {{name}}",
  "cowork.progress.namedDataset": "Dataset: {{name}}",
  "cowork.progress.namedReport": "Report: {{name}}",
  "cowork.progress.section": "Section: {{name}}",
  "cowork.progress.rows": "Rows processed: {{processed}}",
  "cowork.progress.rowsTotal": "Rows processed: {{processed}} / {{total}}",
  "cowork.progress.documents": "Documents processed: {{processed}}",
  "cowork.progress.documentsTotal": "Documents processed: {{processed}} / {{total}}",
  "cowork.progress.items": "Items processed: {{processed}}",
  "cowork.progress.itemsTotal": "Items processed: {{processed}} / {{total}}",
  "cowork.accounting.documents.description":
    "Upload source files and add them as accounting documents for extraction and review.",
  "cowork.accounting.documents.upload": "Upload document",
  "cowork.accounting.documents.uploading": "Uploading...",
  "cowork.accounting.documents.noWorkflow": "Open Accounting from a workflow chat to manage accounting documents.",
  "cowork.accounting.documents.empty": "No accounting documents yet.",
  "cowork.accounting.documents.unknown": "Unknown",
  "cowork.accounting.documents.process": "Process",
  "cowork.accounting.documents.suggestPostings": "Suggest postings",
  "cowork.accounting.documents.copyCell": "Copy cell value",
  "cowork.accounting.documents.visibleRows": "{{count}} visible documents",
  "cowork.accounting.documents.columnFilters": "Column filters",
  "cowork.accounting.documents.allValues": "All",
  "cowork.accounting.documents.noFilterValues": "No values",
  "cowork.accounting.documents.addToAccounting": "Add to Accounting",
  "cowork.accounting.extractions.title": "Extracted document data",
  "cowork.accounting.extractions.description":
    "Review structured values saved by the accounting agent for each document.",
  "cowork.accounting.extractions.filter": "Filter files",
  "cowork.accounting.extractions.empty": "No accounting extraction records saved yet.",
  "cowork.accounting.extractions.record": "Accounting extraction",
  "cowork.accounting.extractions.noTables": "No structured extraction tables saved for this document.",
  "cowork.accounting.extractions.keyValues": "Key values",
  "cowork.accounting.extractions.lineItems": "Line items",
  "cowork.accounting.extractions.sourceFields": "Source fields",
  "cowork.accounting.extractions.accountingFacts": "Extracted accounting facts",
  "cowork.accounting.extractions.confidence": "Confidence: {{confidence}}%",
  "cowork.accounting.extractions.warnings": "{{count}} extraction warnings",
  "cowork.accounting.extractions.party.seller": "Seller",
  "cowork.accounting.extractions.party.buyer": "Buyer",
  "cowork.accounting.extractions.fact.documentType": "Document type",
  "cowork.accounting.extractions.fact.period": "Period",
  "cowork.accounting.extractions.fact.customerNumber": "Customer number",
  "cowork.accounting.extractions.fact.contractNumber": "Contract number",
  "cowork.accounting.extractions.fact.name": "Name",
  "cowork.accounting.extractions.fact.registrationNumber": "Reg. no.",
  "cowork.accounting.extractions.fact.vatNumber": "VAT no.",
  "cowork.accounting.extractions.fact.address": "Address",
  "cowork.accounting.extractions.fact.email": "Email",
  "cowork.accounting.extractions.fact.phone": "Phone",
  "cowork.accounting.extractions.fact.invoiceTotal": "Invoice total",
  "cowork.accounting.extractions.fact.previousBalance": "Previous balance",
  "cowork.accounting.extractions.fact.amountDue": "Amount due",
  "cowork.accounting.extractions.fact.paymentStatus": "Payment status",
  "cowork.accounting.extractions.fact.bank": "Bank",
  "cowork.accounting.extractions.fact.iban": "IBAN",
  "cowork.accounting.extractions.fact.swift": "SWIFT/BIC",
  "cowork.accounting.extractions.fact.paymentReference": "Payment reference",
  "cowork.accounting.extractions.column.field": "Field",
  "cowork.accounting.extractions.column.value": "Value",
  "cowork.accounting.extractions.column.source": "Source",
  "cowork.accounting.extractions.receiptLines": "Receipt lines",
  "cowork.accounting.extractions.invoiceLines": "Invoice lines",
  "cowork.accounting.extractions.vatSummary": "VAT summary",
  "cowork.accounting.extractions.deliveryDetails": "Delivery details",
  "cowork.accounting.extractions.sourceLines": "Source lines",
  "cowork.accounting.extractions.section.document": "Document",
  "cowork.accounting.extractions.section.supplier": "Supplier",
  "cowork.accounting.extractions.section.customer": "Customer",
  "cowork.accounting.extractions.section.payment": "Payment details",
  "cowork.accounting.extractions.section.amounts": "Amounts",
  "cowork.accounting.extractions.section.references": "References",
  "cowork.accounting.extractions.section.comments": "Comments and terms",
  "cowork.accounting.extractions.section.other": "Other extracted fields",
  "cowork.accounting.documents.sourceFiles": "Uploaded source files",
  "cowork.accounting.documents.sourceFilesDescription":
    "Add existing workflow files to Accounting without uploading them again.",
  "cowork.accounting.documents.column.file": "File name",
  "cowork.accounting.documents.column.type": "Document type",
  "cowork.accounting.documents.column.counterparty": "Counterparty",
  "cowork.accounting.documents.column.number": "Document number",
  "cowork.accounting.documents.column.date": "Document date",
  "cowork.accounting.documents.column.currency": "Currency",
  "cowork.accounting.documents.column.gross": "Gross amount",
  "cowork.accounting.documents.column.status": "Processing status",
  "cowork.accounting.documents.column.confidence": "Confidence",
  "cowork.accounting.documents.column.postings": "Postings",
  "cowork.accounting.documents.column.actions": "Actions",
  "cowork.accounting.postings.notGenerated": "Not generated",
  "cowork.accounting.postings.suggested": "Suggested",
  "cowork.accounting.postings.validated": "Validated",
  "cowork.accounting.postings.needsReview": "Needs review",
  "cowork.accounting.review.title": "Review queue",
  "cowork.accounting.review.description":
    "Approve, reject, or revisit accounting documents and posting suggestions that need accountant attention.",
  "cowork.accounting.review.empty": "No accounting review items need attention.",
  "cowork.accounting.review.itemMeta": "Review: {{status}} · Postings: {{postings}}",
  "cowork.accounting.review.approve": "Approve",
  "cowork.accounting.review.reject": "Reject",
  "cowork.accounting.review.systemConfidence": "System confidence: {{confidence}}%",
  "cowork.accounting.review.documentFacts": "Document facts",
  "cowork.accounting.review.sourceReferences": "Source references",
  "cowork.accounting.review.buyer": "Buyer",
  "cowork.accounting.review.supplierVatNumber": "Supplier VAT number",
  "cowork.accounting.review.buyerVatNumber": "Buyer VAT number",
  "cowork.accounting.review.dueDate": "Due date",
  "cowork.accounting.review.paymentMethod": "Payment method",
  "cowork.accounting.review.vehicle": "Vehicle",
  "cowork.accounting.review.net": "Net",
  "cowork.accounting.review.vat": "VAT",
  "cowork.accounting.review.rounding": "Rounding",
  "cowork.accounting.review.documentContent": "Document contents",
  "cowork.accounting.review.lineItems": "Line items",
  "cowork.accounting.review.quantity": "Quantity",
  "cowork.accounting.review.discount": "Discount",
  "cowork.accounting.review.businessPurpose": "Business purpose",
  "cowork.accounting.review.classification": "Suggested classification",
  "cowork.accounting.review.operationType": "Operation type",
  "cowork.accounting.review.category": "Category",
  "cowork.accounting.review.analytics": "Analytics",
  "cowork.accounting.review.vehicleDimension": "Vehicle dimension",
  "cowork.accounting.review.projectDimension": "Project dimension",
  "cowork.accounting.review.personDimension": "Person dimension",
  "cowork.accounting.review.vatTreatment": "VAT treatment",
  "cowork.accounting.review.vatRate": "VAT rate",
  "cowork.accounting.vatTreatment.domesticInput": "Domestic purchase — input VAT",
  "cowork.accounting.vatTreatment.domesticOutput": "Domestic sale — output VAT",
  "cowork.accounting.vatTreatment.euReverseCharge": "EU reverse charge",
  "cowork.accounting.vatTreatment.nonEuImport": "Non-EU import VAT",
  "cowork.accounting.vatTreatment.exempt": "VAT exempt",
  "cowork.accounting.vatTreatment.zeroRated": "Zero-rated VAT",
  "cowork.accounting.vatTreatment.noVat": "No VAT",
  "cowork.accounting.vatTreatment.needsReview": "VAT treatment needs review",
  "cowork.accounting.review.recommendationReason": "Reason for recommendation",
  "cowork.accounting.review.postingPreview": "Suggested postings",
  "cowork.accounting.review.paymentMatch": "Matched payment",
  "cowork.accounting.review.match.supplier": "Supplier matched",
  "cowork.accounting.review.match.amount": "Amount matched",
  "cowork.accounting.review.match.invoice": "Invoice number matched",
  "cowork.accounting.review.match.date": "Date matched",
  "cowork.accounting.review.match.bankCard": "Bank/card matched",
  "cowork.accounting.review.match.confidence": "Confidence explanation",
  "cowork.accounting.review.closingEntries": "Proposed closing entries",
  "cowork.accounting.review.noClosingEntries": "No closing entries proposed yet.",
  "cowork.accounting.review.why": "Why?",
  "cowork.accounting.review.noBusinessData": "No agent-saved business data yet.",
  "cowork.accounting.review.notAvailable": "Not available",
  "cowork.accounting.review.actionsTitle": "Accountant actions",
  "cowork.accounting.review.approveAll": "Approve all",
  "cowork.accounting.review.editPostings": "Edit postings",
  "cowork.accounting.review.editCategory": "Edit category",
  "cowork.accounting.review.editVat": "Edit VAT",
  "cowork.accounting.review.editPayment": "Edit payment",
  "cowork.accounting.payments.title": "Payments",
  "cowork.accounting.payments.description":
    "Review payment transactions and document matches saved by the accounting agent.",
  "cowork.accounting.payments.match": "Match payments",
  "cowork.accounting.payments.importOne": "Import payment",
  "cowork.accounting.payments.amount": "Amount",
  "cowork.accounting.payments.currency": "Currency",
  "cowork.accounting.payments.counterparty": "Counterparty",
  "cowork.accounting.payments.reference": "Reference",
  "cowork.accounting.payments.descriptionField": "Payment description",
  "cowork.accounting.payments.transactions": "Transactions",
  "cowork.accounting.payments.matches": "Document-payment matches",
  "cowork.accounting.payments.empty": "No payment transactions imported yet.",
  "cowork.accounting.payments.noMatches": "No payment matches suggested yet.",
  "cowork.accounting.payments.matchMeta": "Confidence: {{confidence}}% · Status: {{status}}",
  "cowork.accounting.payments.matchConfidence": "Match confidence: {{confidence}}%",
  "cowork.accounting.payments.invoiceDate": "Invoice date",
  "cowork.accounting.payments.paymentDate": "Payment date",
  "cowork.accounting.payments.view.matched": "Matched",
  "cowork.accounting.payments.view.unpaid": "Unpaid invoices",
  "cowork.accounting.payments.view.unmatched": "Unmatched payments",
  "cowork.accounting.payments.unpaidInvoices": "Unpaid invoices",
  "cowork.accounting.payments.noUnpaidInvoices": "No unpaid invoices found.",
  "cowork.accounting.payments.noUnmatchedPayments": "No unmatched payments found.",
  "cowork.accounting.payments.daysOverdue": "Days overdue",
  "cowork.accounting.payments.notOverdue": "Not overdue",
  "cowork.accounting.payments.dueDateMissing": "Due date missing",
  "cowork.accounting.payments.days": "{{count}} days",
  "cowork.accounting.status.created": "Created",
  "cowork.accounting.status.needsExtraction": "Needs extraction",
  "cowork.accounting.status.processed": "Processed",
  "cowork.accounting.status.failed": "Failed",
  "cowork.accounting.documentType.invoice": "Invoice",
  "cowork.accounting.documentType.purchase_invoice": "Purchase invoice",
  "cowork.accounting.documentType.sales_invoice": "Sales invoice",
  "cowork.accounting.documentType.insurance_invoice": "Insurance invoice",
  "cowork.accounting.documentType.leasing_invoice": "Leasing invoice",
  "cowork.accounting.documentType.receipt": "Receipt",
  "cowork.accounting.documentType.payment_notice": "Payment notice",
  "cowork.accounting.documentType.credit_note": "Credit note",
  "cowork.accounting.documentType.supplier_turnover": "Supplier turnover report",
  "cowork.accounting.documentType.customer_balance": "Customer balance report",
  "cowork.accounting.documentType.supplier_balance": "Supplier balance report",
  "cowork.accounting.documentType.trial_balance": "Trial balance",
  "cowork.accounting.documentType.account_trial_balance": "Account trial balance",
  "cowork.accounting.documentType.journal": "Journal",
  "cowork.accounting.documentType.bank_statement": "Bank statement",
  "cowork.accounting.documentType.unknown_accounting_document": "Other accounting document",
  "cowork.accounting.documentType.operation_journal": "Operation journal",
  "cowork.accounting.documentType.fixed_asset_report": "Fixed asset report",
  "cowork.accounting.documentType.depreciation_report": "Depreciation report",
  "cowork.accounting.documentType.account_turnover": "Account turnover report",
  "cowork.accounting.documentType.tax_report": "Tax report",
  "cowork.accounting.tab.documents": "Documents",
  "cowork.accounting.tab.extractions": "Extractions",
  "cowork.accounting.tab.overview": "Overview",
  "cowork.accounting.tab.payments": "Payments",
  "cowork.accounting.tab.review": "Review",
  "cowork.accounting.tab.ledger": "Ledger",
  "cowork.accounting.tab.tax": "Tax",
  "cowork.accounting.tab.emta": "EMTA",
  "cowork.accounting.ledger.empty":
    "Ledger entries will appear here after approved postings are exported to the ledger workflow.",
  "cowork.accounting.ledger.title": "Ledger — {{period}}",
  "cowork.accounting.ledger.header.entries": "{{count}} journal entries",
  "cowork.accounting.ledger.header.debit": "Debit: {{amount}}",
  "cowork.accounting.ledger.header.credit": "Credit: {{amount}}",
  "cowork.accounting.ledger.balanced": "Balanced",
  "cowork.accounting.ledger.imbalance": "Ledger imbalance: Debit exceeds Credit by {{amount}}",
  "cowork.accounting.ledger.openReview": "{{count}} accounting items still require review",
  "cowork.accounting.ledger.view.journal": "Journal",
  "cowork.accounting.ledger.view.trialBalance": "Trial Balance",
  "cowork.accounting.ledger.column.date": "Date",
  "cowork.accounting.ledger.column.document": "Document",
  "cowork.accounting.ledger.column.counterparty": "Counterparty",
  "cowork.accounting.ledger.column.description": "Description",
  "cowork.accounting.ledger.column.debit": "Debit",
  "cowork.accounting.ledger.column.credit": "Credit",
  "cowork.accounting.ledger.column.amount": "Amount",
  "cowork.accounting.ledger.column.status": "Status",
  "cowork.accounting.ledger.column.account": "Account",
  "cowork.accounting.ledger.column.accountName": "Account name",
  "cowork.accounting.ledger.column.rowNumber": "Jrk.nr.",
  "cowork.accounting.ledger.column.journalDate": "Kuupäev",
  "cowork.accounting.ledger.column.journalDebit": "Deebet",
  "cowork.accounting.ledger.column.debitAnalytics": "Analüütika deebet",
  "cowork.accounting.ledger.column.journalCredit": "Kreedit",
  "cowork.accounting.ledger.column.creditAnalytics": "Analüütika kreedit",
  "cowork.accounting.ledger.column.quantity": "Kogus",
  "cowork.accounting.ledger.column.currencyShort": "Val.",
  "cowork.accounting.ledger.column.foreignAmount": "Summa val.",
  "cowork.accounting.ledger.column.journalAmount": "Summa",
  "cowork.accounting.ledger.column.info": "Info",
  "cowork.accounting.ledger.column.journalShort": "Žur.",
  "cowork.accounting.ledger.column.openingBalance": "Opening balance",
  "cowork.accounting.ledger.column.periodTurnover": "Period turnover",
  "cowork.accounting.ledger.column.closingBalance": "Closing balance",
  "cowork.accounting.ledger.column.code": "Code",
  "cowork.accounting.ledger.column.name": "Name",
  "cowork.accounting.ledger.column.openingDebit": "Opening debit",
  "cowork.accounting.ledger.column.openingCredit": "Opening credit",
  "cowork.accounting.ledger.column.periodDebit": "Period debit",
  "cowork.accounting.ledger.column.periodCredit": "Period credit",
  "cowork.accounting.ledger.column.closingDebit": "Closing debit",
  "cowork.accounting.ledger.column.closingCredit": "Closing credit",
  "cowork.accounting.ledger.openingUnavailable": "Unavailable",
  "cowork.accounting.ledger.status.draft": "Draft",
  "cowork.accounting.ledger.status.needsReview": "Needs review",
  "cowork.accounting.ledger.status.approved": "Approved",
  "cowork.accounting.ledger.status.finalized": "Finalized",
  "cowork.accounting.ledger.status.error": "Error",
  "cowork.accounting.reconciliation.title": "Source-pack reconciliation",
  "cowork.accounting.reconciliation.description":
    "Agent-saved checks across journals, balances, invoices, payroll, VAT, and fixed assets.",
  "cowork.accounting.reconciliation.notPrepared": "Not prepared yet",
  "cowork.accounting.reconciliation.journalVsInvoices": "Journal vs invoices",
  "cowork.accounting.reconciliation.trialBalanceVsJournal": "Trial balance vs journal",
  "cowork.accounting.reconciliation.supplierBalances": "Supplier balances",
  "cowork.accounting.reconciliation.customerBalances": "Customer balances",
  "cowork.accounting.reconciliation.fixedAssets": "Fixed assets/depreciation",
  "cowork.accounting.reconciliation.payrollTsd": "Payroll/TSD reconciliation",
  "cowork.accounting.reconciliation.vatKmd": "VAT/KMD reconciliation",
  "cowork.accounting.reconciliation.paymentMatches": "Payment matches",
  "cowork.accounting.reconciliation.fallback.ready": "Source evidence found",
  "cowork.accounting.reconciliation.fallback.reportDocs": "{{count}} source report documents available.",
  "cowork.accounting.reconciliation.fallback.invoiceDocs": "{{count}} invoice/receipt/payment documents available.",
  "cowork.accounting.reconciliation.fallback.reviewBlockers": "{{count}} review items need accountant attention.",
  "cowork.accounting.reconciliation.fallback.operationJournals": "{{count}} operation journal documents available.",
  "cowork.accounting.reconciliation.fallback.trialBalances": "{{count}} trial balance documents available.",
  "cowork.accounting.reconciliation.fallback.supplierBalanceDocs": "{{count}} supplier balance documents available.",
  "cowork.accounting.reconciliation.fallback.customerBalanceDocs": "{{count}} customer balance documents available.",
  "cowork.accounting.reconciliation.fallback.fixedAssetDocs": "{{count}} fixed asset report documents available.",
  "cowork.accounting.reconciliation.fallback.depreciationDocs": "{{count}} depreciation report documents available.",
  "cowork.accounting.reconciliation.fallback.taxReport": "{{type}} draft saved with validation status {{status}}.",
  "cowork.accounting.exports.title": "Export packages",
  "cowork.accounting.exports.description":
    "Create validated ledger export files with idempotency keys and checksums for accountant-controlled submission.",
  "cowork.accounting.exports.create": "Create export package",
  "cowork.accounting.exports.empty": "No export packages created yet.",
  "cowork.accounting.exports.packageTitle": "{{type}} package",
  "cowork.accounting.exports.packageMeta":
    "Status: {{status}} · Validation: {{validation}} · Submission: {{submission}}",
  "cowork.accounting.exports.checksum": "Checksum: {{checksum}}",
  "cowork.accounting.exports.fileMeta": "{{type}} · {{size}} bytes",
  "cowork.accounting.exports.markSubmitted": "Mark submitted manually",
  "cowork.accounting.exports.downloadFile": "Download file",
  "cowork.accounting.exports.deleteFile": "Delete file",
  "cowork.accounting.tax.title": "Tax reports",
  "cowork.accounting.tax.description":
    "Review KMD/TSD drafts, tax summaries, reconciliation, and EMTA-ready files generated by the accounting agent.",
  "cowork.accounting.tax.view.returns": "KMD / TSD",
  "cowork.accounting.tax.view.summary": "Summary",
  "cowork.accounting.tax.view.reconciliation": "Reconciliation",
  "cowork.accounting.tax.view.report": "Report",
  "cowork.accounting.tax.kmdSummary": "KMD summary",
  "cowork.accounting.tax.tsdSummary": "TSD summary",
  "cowork.accounting.tax.accountingSummary": "Accounting summary",
  "cowork.accounting.tax.taxSummary": "Tax summary",
  "cowork.accounting.tax.reconciliation": "Tax reconciliation",
  "cowork.accounting.tax.noReconciliation": "No tax reconciliation details saved yet.",
  "cowork.accounting.tax.reconciliationFallback": "{{type}} saved with validation status {{status}}.",
  "cowork.accounting.tax.generatedDataPreview": "Generated KMD/TSD data",
  "cowork.accounting.tax.accountingTaxData": "Accounting and tax data",
  "cowork.accounting.tax.reconciliationData": "Reconciliation data",
  "cowork.accounting.tax.noPreviewData": "No generated data preview is available yet.",
  "cowork.accounting.tax.preview.field": "Field",
  "cowork.accounting.tax.preview.value": "Value",
  "cowork.accounting.tax.preview.yes": "Yes",
  "cowork.accounting.tax.preview.no": "No",
  "cowork.accounting.tax.preview.status": "Status",
  "cowork.accounting.tax.preview.status.draftReadyForReview": "Draft ready for review",
  "cowork.accounting.tax.preview.company": "Company",
  "cowork.accounting.tax.preview.period": "Period",
  "cowork.accounting.tax.preview.currency": "Currency",
  "cowork.accounting.tax.preview.source_pack_files": "Source files",
  "cowork.accounting.tax.preview.source_pack_operation_journal": "Operation journal files",
  "cowork.accounting.tax.preview.source_pack_trial_balance": "Trial balance files",
  "cowork.accounting.tax.preview.source_pack_account_turnover_reports": "Account turnover reports",
  "cowork.accounting.tax.preview.source_pack_source_invoices_and_receipts": "Source invoices and receipts",
  "cowork.accounting.tax.preview.reconciliation_trial_balance_period_debits": "Trial balance period debits",
  "cowork.accounting.tax.preview.reconciliation_trial_balance_period_credits": "Trial balance period credits",
  "cowork.accounting.tax.preview.reconciliation_customer_opening_collected": "Customer opening collected",
  "cowork.accounting.tax.preview.reconciliation_january_sales_invoices": "January sales invoices",
  "cowork.accounting.tax.preview.reconciliation_closing_trade_receivables": "Closing trade receivables",
  "cowork.accounting.tax.preview.reconciliation_supplier_opening_payables": "Supplier opening payables",
  "cowork.accounting.tax.preview.reconciliation_supplier_invoice_debits_or_settlements":
    "Supplier invoice debits/settlements",
  "cowork.accounting.tax.preview.reconciliation_supplier_invoice_credits_or_additions":
    "Supplier invoice credits/additions",
  "cowork.accounting.tax.preview.reconciliation_closing_trade_payables": "Closing trade payables",
  "cowork.accounting.tax.preview.reconciliation_bank_opening": "Bank opening balance",
  "cowork.accounting.tax.preview.reconciliation_bank_debit_turnover": "Bank debit turnover",
  "cowork.accounting.tax.preview.reconciliation_bank_credit_turnover": "Bank credit turnover",
  "cowork.accounting.tax.preview.reconciliation_bank_closing": "Bank closing balance",
  "cowork.accounting.tax.preview.reconciliation_domestic_input_vat_control": "Domestic input VAT control",
  "cowork.accounting.tax.preview.reconciliation_domestic_output_vat_control": "Domestic output VAT control",
  "cowork.accounting.tax.preview.reconciliation_vat_payable": "VAT payable",
  "cowork.accounting.tax.preview.kmd_taxable_sales_24": "KMD taxable sales 24%",
  "cowork.accounting.tax.preview.kmd_output_vat": "KMD output VAT",
  "cowork.accounting.tax.preview.kmd_input_vat": "KMD input VAT",
  "cowork.accounting.tax.preview.kmd_vat_payable": "KMD VAT payable",
  "cowork.accounting.tax.preview.kmd_eu_reverse_charge_base": "EU reverse-charge base",
  "cowork.accounting.tax.preview.kmd_eu_reverse_charge_vat": "EU reverse-charge VAT",
  "cowork.accounting.tax.preview.tsd_payment_basis": "TSD payment basis",
  "cowork.accounting.tax.preview.tsd_income_tax": "TSD income tax",
  "cowork.accounting.tax.preview.tsd_employee_ui": "Employee unemployment insurance",
  "cowork.accounting.tax.preview.tsd_employer_ui": "Employer unemployment insurance",
  "cowork.accounting.tax.preview.tsd_social_tax": "Social tax",
  "cowork.accounting.tax.preview.reconciliation_journal_balanced": "Journal balanced",
  "cowork.accounting.tax.preview.reconciliation_journal_debit_credit": "Journal debit/credit total",
  "cowork.accounting.tax.preview.reconciliation_trial_balance_closing_debit_credit":
    "Trial balance closing debit/credit",
  "cowork.accounting.tax.preview.reconciliation_sales_invoices_match_customer_ledger":
    "Sales invoices match customer ledger",
  "cowork.accounting.tax.preview.reconciliation_fixed_asset_cost": "Fixed asset cost",
  "cowork.accounting.tax.preview.reconciliation_depreciation": "Depreciation",
  "cowork.accounting.tax.preview.review_blockers": "Review blockers",
  "cowork.accounting.tax.preview.sourceReference": "Source reference",
  "cowork.accounting.tax.generateXmlTitle": "Generate KMD/TSD XML files",
  "cowork.accounting.tax.generateXmlDescription":
    "Ask the accounting agent to create EMTA-compatible XML files when you are ready to download and submit manually.",
  "cowork.accounting.tax.generateXmlPrompt": "Generate KMD and TSD XML files for EMTA",
  "cowork.accounting.tax.notGenerated": "Not generated yet",
  "cowork.accounting.tax.askAgent": "Ask the accounting agent to generate this report.",
  "cowork.accounting.tax.periodStatus": "{{period}} · {{status}}",
  "cowork.accounting.tax.documents": "Documents",
  "cowork.accounting.tax.approvedPostings": "Approved postings",
  "cowork.accounting.tax.validation": "Validation",
  "cowork.accounting.tax.kmdVatPayable": "KMD VAT payable",
  "cowork.accounting.tax.tsdPayroll": "TSD payroll payments",
  "cowork.accounting.tax.status.passed": "Passed",
  "cowork.accounting.tax.status.failed": "Failed",
  "cowork.accounting.tax.status.needsReview": "Needs review",
  "cowork.accounting.tax.status.pending": "Pending",
  "cowork.accounting.tax.create": "Create tax report",
  "cowork.accounting.tax.type.kmd": "KMD VAT return",
  "cowork.accounting.tax.type.tsd": "TSD payroll return",
  "cowork.accounting.tax.approve": "Approve report",
  "cowork.accounting.tax.reject": "Reject report",
  "cowork.accounting.tax.deleteReport": "Delete report",
  "cowork.accounting.tax.generatedFiles": "Report files",
  "cowork.accounting.tax.noGeneratedFiles":
    "No downloadable KMD/TSD files generated yet. EMTA filing is primarily XML; ask the agent to generate XML files when ready.",
  "cowork.accounting.tax.xmlFiles": "KMD/TSD XML files",
  "cowork.accounting.tax.noXmlFiles":
    "No KMD/TSD XML files generated yet. Ask the accounting agent to generate XML files for EMTA when the report data is ready.",
  "cowork.accounting.tax.downloadArtifact": "Download tax file",
  "cowork.accounting.tax.deleteArtifact": "Delete tax file",
  "cowork.accounting.tax.sourcesTitle": "Official sources",
  "cowork.accounting.tax.sourcesEmpty": "Official tax guidance will appear here after a report is created.",
  "cowork.accounting.tax.reportTitle": "{{type}} for {{period}}",
  "cowork.accounting.tax.reportMeta": "Status: {{status}} · Validation: {{validation}} · Approval: {{approval}}",
  "cowork.accounting.tax.reportCounts": "{{documents}} documents · {{postings}} approved posting groups",
  "cowork.accounting.tax.kmdTotals": "KMD VAT payable: {{amount}}",
  "cowork.accounting.tax.tsdTotals": "TSD payroll payments: {{amount}}",
  "cowork.accounting.tax.empty":
    "Tax reports will appear here after accounting postings are mapped and validated for KMD/TSD preparation.",
  "cowork.accounting.emta.empty":
    "EMTA submission packages and status receipts will appear here after tax reports are validated and approved.",
  "cowork.accounting.overview.title": "Accounting overview",
  "cowork.accounting.overview.description": "Month-end readiness, warnings, and next actions for the selected period.",
  "cowork.accounting.overview.ready": "Ready to close",
  "cowork.accounting.overview.notReady": "Not ready to close",
  "cowork.accounting.overview.checks": "Readiness checks",
  "cowork.accounting.overview.warnings": "Warnings",
  "cowork.accounting.overview.nextActions": "Next actions",
  "cowork.accounting.overview.noChecks": "No checks available yet.",
  "cowork.accounting.overview.noWarnings": "No warnings.",
  "cowork.accounting.overview.noActions": "No actions needed.",
  "cowork.accounting.readiness.check.documents_processed": "Documents processed",
  "cowork.accounting.readiness.check.payments_matched": "Payments matched",
  "cowork.accounting.readiness.check.postings_balanced": "Postings balanced",
  "cowork.accounting.readiness.check.reviews_resolved": "Reviews resolved",
  "cowork.accounting.readiness.check.exports_ready": "Export package ready",
  "cowork.accounting.readiness.warning.duplicate_documents": "{{count}} possible duplicate documents need review.",
  "cowork.accounting.readiness.warning.unmatched_documents": "{{count}} documents do not have matched payments.",
  "cowork.accounting.readiness.warning.vat_review": "{{count}} documents have low VAT confidence.",
  "cowork.accounting.readiness.warning.open_reviews": "{{count}} review items are still open.",
  "cowork.accounting.readiness.warning.postings_not_approved": "{{count}} posting groups are not approved.",
  "cowork.accounting.readiness.action.upload_documents": "Upload documents",
  "cowork.accounting.readiness.action.match_payments": "Match payments",
  "cowork.accounting.readiness.action.resolve_reviews": "Resolve reviews",
  "cowork.accounting.readiness.action.create_export": "Create export package",
  "cowork.newChat.title": "New chat",
  "cowork.newChat.description": "Choose a project and reporting workflow before starting a chat.",
  "cowork.newChat.scopeDescription": "Choose which workspace data this chat can access.",
  "cowork.newChat.scope.workspace": "Workspace",
  "cowork.newChat.scope.workspace.description":
    "Access files, data, outputs, and reports across all available companies and projects.",
  "cowork.newChat.scope.company": "Company",
  "cowork.newChat.scope.company.description": "Access files, data, outputs, and reports across one company.",
  "cowork.newChat.scope.project": "Project",
  "cowork.newChat.scope.project.description": "Limit access to one selected project.",
  "cowork.newChat.scope.currentProject": "Current project: {{project}}",
  "cowork.newChat.currentProject": "Current project",
  "cowork.newChat.close": "Close new chat",
  "cowork.newChat.currentProjectDescription": "Start a chat in the project currently selected in the top bar.",
  "cowork.newChat.selectProjectFirst": "Select a project before starting a new chat.",
  "cowork.newChat.starting": "Starting chat...",
  "cowork.newChat.failed": "Chat could not be started",
  "cowork.newChat.retry": "Try again",
  "cowork.newChat.timeout": "Chat startup timed out. Please try again.",
  "cowork.newChat.runtimeTimeout": "Connecting to the chat runtime timed out. Please try again.",
  "cowork.newChat.workspaceTitle": "Workspace chat",
  "cowork.newChat.companyTitle": "{{company}} chat",
  "cowork.newChat.projectTitle": "{{project}} · {{timestamp}}",
  "cowork.newChat.workflowOptional": "Workflow (optional)",
  "cowork.newChat.noWorkflow": "No workflow",
  "cowork.newChat.noScopedProjects": "This scope has no accessible projects or data yet.",
  "cowork.newChat.project": "Project",
  "cowork.newChat.workflow": "Workflow",
  "cowork.newChat.create": "Create chat",
  "cowork.newChat.creating": "Creating...",
  "cowork.newChat.noProjects": "Create a project first to start a chat.",
  "cowork.newChat.workflowRequired.title": "Workflow required",
  "cowork.newChat.workflowRequired.description": "Create and choose a workflow before starting a new chat.",
  "cowork.chat.deleteTitle": "Delete chat",
  "cowork.chat.deleteConfirm": 'Delete chat "{{name}}"?',
  "cowork.chat.deleteDescription":
    "This removes the chat from this workflow. Generated outputs, files, and workflow records remain available unless you delete them separately.",
  "cowork.chat.delete": "Delete chat",
  "cowork.chat.downloads": "Generated files",
  "cowork.chat.dismissDownload": "Hide generated file card",
  "cowork.agent.settings.title": "Agent settings",
  "cowork.agent.settings.menu.reportLanguage": "Report language",
  "cowork.agent.settings.menu.reportTemplate": "Report template",
  "cowork.chat.viewFiles": "View workflow",
  "cowork.agent.settings.templates.title": "Report templates",
  "cowork.agent.settings.templates.description":
    "Choose a ready-to-use report template. Generate will run it in the current company, project, and period context.",
  "cowork.agent.settings.templates.generate": "Generate",
  "cowork.agent.settings.templates.selected": "Selected template",
  "cowork.agent.settings.templates.group.core.title": "Core accounting reports",
  "cowork.agent.settings.templates.group.core.description":
    "Financial analysis and management reports for the current company and period.",
  "cowork.agent.settings.templates.group.estonia.title": "Estonian accounting reports",
  "cowork.agent.settings.templates.group.estonia.description":
    "Estonian terminology and presentation based on the entity accounting profile.",
  "cowork.agent.settings.templates.format.xlsx": "Excel",
  "cowork.agent.settings.templates.format.analysis": "Analysis",
  "cowork.agent.settings.templates.format.dashboard": "Dashboard",
  "cowork.agent.settings.templates.format.estonia": "Estonia",
  "cowork.agent.settings.template.accountCard.title": "Account Card / Kontokaart",
  "cowork.agent.settings.template.accountCard.description": "Excel ledger card with account movements, corresponding accounts, opening balance, turnover and running balances.",
  "cowork.agent.settings.template.accountCard.visiblePrompt": "Generate an Excel Account Card for one GL account and period",
  "cowork.agent.settings.template.accountCard.selectedPrompt": "Generate an Excel Account Card for account {{account}} for the selected period, excluding subaccounts",
  "cowork.agent.settings.template.accountCard.selectedPromptWithSubaccounts": "Generate an Excel Account Card for account {{account}} for the selected period, including subaccounts",
  "cowork.agent.settings.template.accountCard.accountCode": "GL account code",
  "cowork.agent.settings.template.accountCard.includeSubaccounts": "Include subaccounts",
  "cowork.agent.settings.template.accountCard.selectPeriod": "Select one reporting period for the Account Card.",
  "cowork.agent.settings.template.trialBalance.title": "Trial Balance / Käibeandmik",
  "cowork.agent.settings.template.trialBalance.description":
    "Opening balances, debit and credit turnover, closing balances, movements, and exceptions in Excel.",
  "cowork.agent.settings.template.trialBalance.visiblePrompt": "Generate Trial Balance / Käibeandmik for Estonia",
  "cowork.agent.settings.template.journal.title": "Journal / Päevaraamat",
  "cowork.agent.settings.template.journal.description": "Excel journal with posting and document dates, debit and credit accounts, amounts, analytics, and source references.",
  "cowork.agent.settings.template.journal.visiblePrompt": "Generate Journal / Päevaraamat for Estonia",
  "cowork.agent.settings.template.pnl.title": "Profit and Loss Report",
  "cowork.agent.settings.template.pnl.description":
    "Revenue, expenses, operating result, margins, trends, and material variance drivers.",
  "cowork.agent.settings.template.pnl.visiblePrompt": "Generate Profit and Loss Report",
  "cowork.agent.settings.template.balanceSheet.title": "Balance Sheet Analysis",
  "cowork.agent.settings.template.balanceSheet.description":
    "Assets, liabilities, equity, working capital, ratios, material movements, and reconciliation.",
  "cowork.agent.settings.template.balanceSheet.visiblePrompt": "Generate Balance Sheet Analysis",
  "cowork.agent.settings.template.management.title": "Management Report",
  "cowork.agent.settings.template.management.description":
    "KPIs, trends, specialist analyses, exceptions, explanations, and management attention items.",
  "cowork.agent.settings.template.management.visiblePrompt": "Generate Management Report",
  "cowork.agent.settings.template.cashBank.title": "Cash and Bank Analysis",
  "cowork.agent.settings.template.cashBank.description":
    "Balances, inflows, outflows, cash movement, account concentration, and reconciliation indicators.",
  "cowork.agent.settings.template.cashBank.visiblePrompt": "Generate Cash and Bank Analysis",
  "cowork.agent.settings.template.arAp.title": "AR/AP Ageing Analysis",
  "cowork.agent.settings.template.arAp.description":
    "Outstanding customers and suppliers, ageing, concentration, overdue balances, and reconciliation.",
  "cowork.agent.settings.template.arAp.visiblePrompt": "Generate AR/AP Ageing Analysis",
  "cowork.agent.settings.template.bilanss.title": "Eesti Bilanss",
  "cowork.agent.settings.template.bilanss.description":
    "Estonian balance sheet terminology and presentation with comparison, movements, and validation.",
  "cowork.agent.settings.template.bilanss.visiblePrompt": "Generate Eesti Bilanss",
  "cowork.agent.settings.template.kasumiaruanne.title": "Eesti Kasumiaruanne",
  "cowork.agent.settings.template.kasumiaruanne.description":
    "Estonian income statement using the entity's approved Scheme 1 or Scheme 2 mapping.",
  "cowork.agent.settings.template.kasumiaruanne.visiblePrompt": "Generate Eesti Kasumiaruanne",
  "cowork.agent.settings.template.kmd.title": "KMD VAT Return Draft",
  "cowork.agent.settings.template.kmd.description":
    "EMTA-format XML draft and supporting Excel workbook with applicable KMD INF annexes, validation, and review.",
  "cowork.agent.settings.template.kmd.visiblePrompt": "Generate an Estonian KMD VAT return draft as EMTA XML with a supporting Excel workbook",
  "cowork.agent.settings.template.tsd.title": "TSD Tax Return Draft",
  "cowork.agent.settings.template.tsd.description":
    "Draft Estonian income and social tax declaration with applicable annexes, source coverage, and required review.",
  "cowork.agent.settings.template.tsd.visiblePrompt": "Generate an Estonian TSD tax return draft as EMTA XML with a supporting Excel workbook",
  "cowork.agent.settings.reportLanguage.title": "Report output language",
  "cowork.agent.settings.reportLanguage.description": "Choose the default language for generated report files.",
  "cowork.agent.settings.reportLanguage.option.app": "Application language",
  "cowork.agent.settings.reportLanguage.option.en": "English",
  "cowork.agent.settings.reportLanguage.option.ru": "Russian",
  "cowork.agent.settings.reportLanguage.option.et": "Estonian",
  "cowork.agent.settings.reportLanguage.option.de": "German",
  "cowork.agent.settings.reportLanguage.option.fr": "French",
  "cowork.agent.settings.reportLanguage.option.es": "Spanish",
  "cowork.projects.create": "Create",
  "cowork.projects.empty": "No projects yet.",
  "cowork.projects.role": "{{role}} access",
  "cowork.projects.readOnly": "You have read-only access to this project.",
  "cowork.files.title": "Source files",
  "cowork.files.upload": "Upload",
  "cowork.files.uploading": "Uploading...",
  "cowork.files.empty": "Upload Excel, PDF, Word, CSV, or JSON files.",
  "cowork.files.size": "{{size}} bytes",
  "cowork.files.panel.title": "Uploaded files",
  "cowork.files.panel.count": "Number of files: {{count}}",
  "cowork.files.panel.upload": "Upload",
  "cowork.files.panel.uploading": "Uploading...",
  "cowork.files.panel.filter": "Filter files",
  "cowork.files.panel.empty": "No files uploaded for this workflow.",
  "cowork.files.panel.noContext": "Open a Andmera chat from a project workflow to view uploaded files.",
  "cowork.files.panel.noFileTitle": "No file selected",
  "cowork.files.panel.noFileDescription": "Upload or select a file to preview its contents.",
  "cowork.files.panel.noPreview": "No preview available for this file.",
  "cowork.files.panel.loadingPreview": "Loading preview…",
  "cowork.files.panel.slide": "Slide {{index}}",
  "cowork.files.panel.fileMeta": "{{size}} bytes · {{type}}",
  "cowork.files.panel.delete": "Delete",
  "cowork.files.panel.download": "Download",
  "cowork.files.library.description": "All files uploaded across your projects.",
  "cowork.files.library.empty": "No uploaded files yet.",
  "cowork.files.library.allProjects": "All projects",
  "cowork.files.library.noWorkflow": "No workflow",
  "cowork.files.library.filter.all": "All",
  "cowork.files.library.filter.documents": "Documents",
  "cowork.files.library.filter.images": "Images",
  "cowork.files.library.filter.spreadsheets": "Spreadsheets",
  "cowork.files.library.modified": "Modified",
  "cowork.files.library.name": "Name",
  "cowork.files.library.project": "Project",
  "cowork.files.library.size": "Size",
  "cowork.pipeline.files": "Files",
  "cowork.pipeline.extractions": "Extractions",
  "cowork.pipeline.transformations": "Transformations",
  "cowork.pipeline.output": "Output",
  "cowork.pipeline.report": "Report",
  "cowork.pipeline.report.refresh": "Refresh report",
  "cowork.pipeline.report.download": "Download",
  "cowork.pipeline.report.delete": "Delete",
  "cowork.report.expand": "Expand report preview",
  "cowork.report.export": "Export report",
  "cowork.report.export.title": "Export report",
  "cowork.report.export.description": "Choose a format to export {{title}}.",
  "cowork.report.export.prompt":
    'Convert the generated report file "{{title}}" from {{currentFormat}} to {{targetFormat}}. Save the converted file as a new report artifact for this workflow and make it available for download.',
  "cowork.pipeline.report.previewScale": "Preview scale {{scale}}",
  "cowork.pipeline.report.zoomIn": "Zoom in",
  "cowork.pipeline.report.zoomOut": "Zoom out",
  "cowork.pipeline.report.previewUnavailable":
    "Preview is not available for this file type. Download the report to view it.",
  "cowork.pipeline.report.pdfLoading": "PDF preview is loading...",
  "cowork.pipeline.report.docxPreviewTitle": "Word preview: {{title}}",
  "cowork.pipeline.report.docxPreviewError": "This Word document could not be previewed. Download it to view the original file.",
  "cowork.pipeline.approval": "Approval",
  "cowork.pipeline.openFullView": "Open full view",
  "cowork.pipeline.exitFullView": "Exit full view",
  "cowork.approval.description": "Prepare, route, and track report review decisions across assigned reviewers.",
  "cowork.approval.requestReview": "Request review",
  "cowork.approval.editReviewers": "Edit reviewers",
  "cowork.approval.doneEditing": "Done editing",
  "cowork.approval.request.title": "Request report review",
  "cowork.approval.request.description":
    "Send reviewers a dedicated link where they can view only the generated report.",
  "cowork.approval.request.report": "Report",
  "cowork.approval.request.reviewers": "Reviewer emails",
  "cowork.approval.request.reviewers.placeholder": "name@example.com, reviewer@example.com",
  "cowork.approval.request.message": "Message",
  "cowork.approval.request.message.placeholder": "Optional note for reviewers",
  "cowork.approval.request.sending": "Sending...",
  "cowork.approval.metric.reviewers": "Reviewers",
  "cowork.approval.metric.pending": "Pending",
  "cowork.approval.metric.approved": "Approved",
  "cowork.approval.metric.rejected": "Rejected",
  "cowork.approval.package.title": "Approval package",
  "cowork.approval.package.description": "Share the generated report, evidence, and decision request with reviewers.",
  "cowork.approval.check.report": "Report generated",
  "cowork.approval.check.reviewers": "Reviewers assigned",
  "cowork.approval.check.audit": "Audit trail ready",
  "cowork.approval.check.status.complete": "Complete",
  "cowork.approval.check.status.pending": "Pending",
  "cowork.approval.table.reviewer": "Reviewer",
  "cowork.approval.table.required": "Required",
  "cowork.approval.table.status": "Status",
  "cowork.approval.table.updated": "Last updated",
  "cowork.approval.reviewer.role": "Report reviewer",
  "cowork.approval.status.approved": "Approved",
  "cowork.approval.status.rejected": "Rejected",
  "cowork.approval.status.viewed": "Viewed",
  "cowork.approval.status.pending": "Pending",
  "cowork.approval.timeline.title": "Workflow timeline",
  "cowork.approval.timeline.reportReady": "Report package ready",
  "cowork.approval.timeline.reviewersAssigned": "Reviewers assigned",
  "cowork.approval.timeline.awaitingReview": "Awaiting reviewer decision",
  "cowork.approval.timeline.finalDecision": "Final decision captured",
  "cowork.approval.timeline.status.complete": "Complete",
  "cowork.approval.timeline.status.working": "In progress",
  "cowork.approval.timeline.status.pending": "Pending",
  "cowork.approval.comments.title": "Reviewer comments",
  "cowork.approval.comments.empty": "No reviewer comments yet.",
  "cowork.review.loading": "Loading review...",
  "cowork.review.unavailable": "This review is unavailable or the link is invalid.",
  "cowork.review.panel.title": "Review & comments",
  "cowork.review.panel.collapse": "Collapse review and comments",
  "cowork.review.panel.expand": "Expand review and comments",
  "cowork.review.panel.description": "Read the report, leave feedback, and record your decision.",
  "cowork.review.history.title": "Conversation",
  "cowork.review.history.empty": "No comments yet.",
  "cowork.review.history.previous": "Previous comment",
  "cowork.review.history.request": "Review requested",
  "cowork.review.history.approved": "Approved the report",
  "cowork.review.history.rejected": "Rejected the report",
  "cowork.review.addComment": "Add a comment",
  "cowork.review.commentPlaceholder": "Write a comment...",
  "cowork.review.postComment": "Post comment",
  "cowork.review.commentAdded": "Comment added.",
  "cowork.review.actionError": "Could not save your response. Your comment is still here; please try again.",
  "cowork.review.subtitle": "Review requested for {{email}}",
  "cowork.review.requestedBy": "Requested by {{user}}",
  "cowork.review.loadingReport": "Loading report...",
  "cowork.review.decision.title": "Review decision",
  "cowork.review.decision.description":
    "Review the report below, add optional comments, then approve or reject the report.",
  "cowork.review.comments": "Comments",
  "cowork.review.comments.placeholder": "Add comments for the Andmera team",
  "cowork.review.saveComments": "Save comment",
  "cowork.review.savingComments": "Saving...",
  "cowork.review.approve": "Approve",
  "cowork.review.approving": "Approving...",
  "cowork.review.reject": "Reject",
  "cowork.review.rejecting": "Rejecting...",
  "cowork.review.status.approved": "Approved",
  "cowork.review.status.rejected": "Rejected",
  "cowork.review.status.pending": "Pending",
  "cowork.pipeline.extraction.empty": "No extracted tables have been saved for this workflow yet.",
  "cowork.pipeline.extraction.noTable": "No table data available for this extraction.",
  "cowork.pipeline.extraction.categorySummary": "{{tables}} tables · {{rows}} rows",
  "cowork.pipeline.extraction.tables": "Tables",
  "cowork.pipeline.extraction.table": "Table",
  "cowork.pipeline.extraction.tableMeta": "{{rows}} rows · {{columns}} columns",
  "cowork.pipeline.transformation.empty": "No transformed outputs have been saved for this workflow yet.",
  "cowork.pipeline.transformation.sources": "Source tables",
  "cowork.pipeline.transformation.steps": "Transformation steps",
  "cowork.pipeline.transformation.validations": "Validation checks",
  "cowork.pipeline.transformation.assumptions": "Assumptions",
  "cowork.pipeline.transformation.preview": "Output preview",
  "cowork.pipeline.records.count": "{{count}} records",
  "cowork.pipeline.records.latest": "Latest",
  "cowork.pipeline.records.search": "Search records",
  "cowork.pipeline.records.allStatuses": "All statuses",
  "cowork.pipeline.records.tables": "tables",
  "cowork.pipeline.records.metric.tables": "Tables",
  "cowork.pipeline.records.metric.status": "Status",
  "cowork.pipeline.records.metric.sourceFile": "Source file",
  "cowork.pipeline.records.metric.created": "Created",
  "cowork.pipeline.records.metric.updated": "Updated",
  "cowork.pipeline.output.empty": "No final output tables have been saved for this workflow yet.",
  "cowork.pipeline.output.count": "{{count}} output tables",
  "cowork.pipeline.output.rows": "rows",
  "cowork.pipeline.output.columns": "columns",
  "cowork.pipeline.output.version": "Version",
  "cowork.pipeline.output.reportUsage": "Report usage",
  "cowork.pipeline.output.filterByReport": "Filter by report",
  "cowork.pipeline.output.allReports": "All reports",
  "cowork.pipeline.output.notUsedInReport": "Not used in a report",
  "cowork.pipeline.output.usedInReport": "Used in {{title}}",
  "cowork.pipeline.output.usedInReports": "Used in {{count}} reports",
  "cowork.pipeline.output.sourceTransformation": "Source transformation",
  "cowork.pipeline.output.copy": "Copy table",
  "cowork.pipeline.output.downloadCsv": "Download CSV",
  "cowork.pipeline.output.search": "Search within selected table",
  "cowork.pipeline.report.empty": "No generated report has been saved for this workflow yet.",
  "cowork.pipeline.approval.empty": "No approval request has been created for this workflow yet.",
  "settings.section.cowork": "Andmera",
  "cowork.settings.agents.title": "Agents",
  "cowork.settings.agents.description": "Choose which Andmera agent should be selected for new chats by default.",
  "cowork.settings.agents.default.title": "Default chat agent",
  "cowork.settings.agents.default.description":
    "New Andmera chats will start with this agent unless changed in the chat.",
  "cowork.company.default": "Andmera",
  "cowork.members.title": "Members",
  "cowork.members.project": "Project",
  "cowork.members.project.description": "Choose the project whose members you want to manage.",
  "cowork.members.invite": "Invite member",
  "cowork.members.invite.description": "Invite a teammate by email address or user ID and choose their project role.",
  "cowork.members.placeholder": "User ID or email",
  "cowork.members.add": "Add",
  "cowork.members.adding": "Adding...",
  "cowork.members.remove": "Remove",
  "cowork.members.empty": "No project members yet.",
  "cowork.members.empty.description": "Invited project members will appear here.",
  "cowork.members.readOnly": "Only project owners can manage members.",
  "cowork.members.readOnly.description": "Ask a project owner to invite or remove members.",
  "cowork.members.error": "Member update failed",
  "cowork.members.role.viewer": "Viewer",
  "cowork.members.role.editor": "Editor",
  "cowork.integrations.menu": "Integrations",
  "cowork.integrations.title": "Integrations",
  "cowork.integrations.description":
    "Connect cloud drives, collaboration tools, CRMs, and workflow systems so Andmera Agent can use them as source context.",
  "cowork.integrations.available": "Available",
  "cowork.integrations.planned": "Planned",
  "cowork.integrations.connected": "Connected",
  "cowork.integrations.connect": "Connect",
  "cowork.integrations.disconnect": "Disconnect",
  "cowork.integrations.refresh": "Refresh connections",
  "cowork.integrations.import.description": "Choose files from connected integrations and import them into this chat.",
  "cowork.integrations.import.browseFiles": "Browse files",
  "cowork.integrations.import.connectedSources": "Connected sources",
  "cowork.integrations.import.empty": "No connected integrations yet.",
  "cowork.integrations.import.file": "Cloud file",
  "cowork.integrations.import.folder": "Folder",
  "cowork.integrations.import.importing": "Importing...",
  "cowork.integrations.import.noFiles": "No files found for this integration.",
  "cowork.integrations.import.root": "Root",
  "cowork.integrations.import.selected": "Import {{count}} selected",
  "cowork.integrations.import.selectedCount": "{{count}} files selected",
  "cowork.integrations.reconnect": "Reconnect",
  "cowork.integrations.empty": "No integrations match your search.",
  "cowork.integrations.description.accounting":
    "Connect accounting records, invoices, payments, and finance exports from {{name}}.",
  "cowork.integrations.description.airtable": "Sync structured operational tables and workflow trackers.",
  "cowork.integrations.description.ai": "Use {{name}} workspace data and model operations as Andmera workflow context.",
  "cowork.integrations.description.analytics": "Import analytics, dashboards, and operational insights from {{name}}.",
  "cowork.integrations.description.asana": "Connect task management workflows and compliance projects.",
  "cowork.integrations.description.aws":
    "Connect large-scale financial datasets, exports, and structured files from AWS.",
  "cowork.integrations.description.azure-blob-storage":
    "Access enterprise data lakes, filings, and financial exports stored in Azure.",
  "cowork.integrations.description.box": "Sync enterprise documents and regulatory files from Box.",
  "cowork.integrations.description.communication":
    "Capture communications, messages, and collaboration records from {{name}}.",
  "cowork.integrations.description.compliance":
    "Import compliance evidence, controls, and audit context from {{name}}.",
  "cowork.integrations.description.confluence": "Import knowledge base articles, procedures, and audit documentation.",
  "cowork.integrations.description.content": "Sync content, documents, and published records from {{name}}.",
  "cowork.integrations.description.crmGeneric":
    "Access CRM records, contacts, accounts, and customer activity from {{name}}.",
  "cowork.integrations.description.devtools":
    "Connect engineering activity, repositories, issues, and release history from {{name}}.",
  "cowork.integrations.description.documents":
    "Import documents, contracts, signatures, and review evidence from {{name}}.",
  "cowork.integrations.description.dropbox": "Import team files and compliance evidence from Dropbox.",
  "cowork.integrations.description.ecommerce":
    "Connect commerce orders, customers, products, and operational records from {{name}}.",
  "cowork.integrations.description.figma": "Import product designs, workflow diagrams, and UI documentation.",
  "cowork.integrations.description.github":
    "Access repositories, documentation, and release history for technical audit trails.",
  "cowork.integrations.description.gitlab": "Import DevOps activity, CI/CD logs, and engineering documentation.",
  "cowork.integrations.description.google-cloud-storage":
    "Import cloud-hosted datasets, reports, and operational files.",
  "cowork.integrations.description.google-drive":
    "Import Excel, PDF, fund reports, investor files, and compliance documents from Google Drive.",
  "cowork.integrations.description.hr":
    "Import HR records, employee data, hiring workflows, and people operations context from {{name}}.",
  "cowork.integrations.description.hubspot":
    "Import customer interactions, onboarding data, and communication history.",
  "cowork.integrations.description.iam": "Connect identity, access, and security events from {{name}}.",
  "cowork.integrations.description.intercom":
    "Access customer conversations, onboarding chats, and support interactions.",
  "cowork.integrations.description.jira": "Connect tickets, audit tasks, and remediation workflows.",
  "cowork.integrations.description.knowledge":
    "Import knowledge base content, learning records, and source documentation from {{name}}.",
  "cowork.integrations.description.linear":
    "Import engineering issues, release planning, and product execution workflows.",
  "cowork.integrations.description.marketing":
    "Sync campaigns, contacts, engagement data, and marketing operations from {{name}}.",
  "cowork.integrations.description.microsoft-teams": "Sync chats, meeting files, and collaboration records.",
  "cowork.integrations.description.notion": "Use internal notes, policies, and procedures as workflow context.",
  "cowork.integrations.description.one-drive":
    "Sync Microsoft OneDrive documents into Andmera reporting and review workflows.",
  "cowork.integrations.description.payments":
    "Connect payment records, invoices, disputes, and transaction context from {{name}}.",
  "cowork.integrations.description.productivity":
    "Connect tasks, calendars, projects, and team workflows from {{name}}.",
  "cowork.integrations.description.salesforce": "Access CRM records, investor data, and client activities.",
  "cowork.integrations.description.sales":
    "Import sales conversations, pipeline context, and customer activity from {{name}}.",
  "cowork.integrations.description.sharepoint-online":
    "Connect SharePoint sites, folders, and team documents for workflow automation.",
  "cowork.integrations.description.slack":
    "Capture operational discussions, approvals, and compliance-related conversations.",
  "cowork.integrations.description.trello": "Access boards, checklists, and operational workflows.",
  "cowork.integrations.description.ticketing":
    "Import tickets, support issues, service history, and remediation workflows from {{name}}.",
  "cowork.integrations.description.webflow": "Sync website content, published pages, and CMS data.",
  "cowork.integrations.description.wordpress": "Import website articles, disclosures, and published content.",
  "cowork.integrations.description.zendesk": "Import support tickets, customer issues, and service history.",
  "cowork.artifacts.title": "Reports",
  "cowork.artifacts.empty": "Generated reports will appear here.",
  "cowork.artifacts.status": "Status: {{status}}",
  "cowork.artifacts.type": "Type: {{type}}",
  "cowork.artifacts.download": "Download",
  "cowork.artifacts.downloading": "Downloading...",
  "cowork.sessions.title": "Sessions",
  "cowork.sessions.new": "New chat",
  "cowork.sessions.empty": "No chat sessions yet.",
  "cowork.session.defaultTitle": "New custom report chat",
  "cowork.chat.title": "Report chat",
  "cowork.chat.subtitle": "Ask the agent to inspect files, extract data, transform results, or draft a report.",
  "cowork.chat.empty": "Create a session and start chatting to build a report.",
  "cowork.chat.user": "You",
  "cowork.chat.assistant": "Andmera Agent",
  "cowork.chat.thinking": "Thinking...",
  "cowork.chat.placeholder": "Ask the agent to generate a report from uploaded files...",
  "cowork.chat.hint": "Uploaded files are sent as scoped project context.",
  "cowork.chat.send": "Send",
  "cowork.chat.streaming": "Working...",
  "cowork.login.title": "Sign in to Andmera",
  "cowork.login.brand": "Andmera",
  "cowork.login.subtitle": "Sign in to your Andmera workspace.",
  "cowork.login.badge": "Agentic Reporting Platform",
  "cowork.login.heroTitle": "Your data already contains the report.",
  "cowork.login.heroDescription":
    "Give Andmera your data, rules and reporting objective. Let it handle the preparation, validation and investigation.",
  "cowork.login.feature.agents.title": "Any data. One reporting layer.",
  "cowork.login.feature.agents.description":
    "Work across spreadsheets, PDFs, accounting exports, databases and APIs without rebuilding every report from scratch.",
  "cowork.login.feature.connected.title": "Reports that validate themselves.",
  "cowork.login.feature.connected.description":
    "Deterministic calculations, reconciliation controls and mapping checks run before a report reaches human review.",
  "cowork.login.feature.realWork.title": "Every number has a source.",
  "cowork.login.feature.realWork.description":
    "Follow a report figure through accounts, categories, calculations and transactions to its original source document.",
  "cowork.login.panel.title": "Welcome back",
  "cowork.login.panel.description": "Sign in to your Andmera workspace.",
  "cowork.login.signinTitle": "Welcome back",
  "cowork.login.signupTitle": "Create your Andmera workspace",
  "cowork.login.signinDescription": "Sign in to your Andmera workspace.",
  "cowork.login.signupDescription": "Agents prepare. Experts stay in control.",
  "cowork.login.passwordSubtitle": "Sign in to your Andmera workspace.",
  "cowork.login.signinTab": "Sign in",
  "cowork.login.signupTab": "Sign up",
  "cowork.login.email": "Email",
  "cowork.login.workEmail": "Work email",
  "cowork.login.emailPlaceholder": "you@example.com",
  "cowork.login.fullName": "Full name",
  "cowork.login.fullNamePlaceholder": "Your full name",
  "cowork.login.organization": "Organization",
  "cowork.login.organizationPlaceholder": "Organization name",
  "cowork.login.organizationHint": "This will be your workspace name.",
  "cowork.login.password": "Password",
  "cowork.login.passwordPlaceholder": "At least 8 characters",
  "cowork.login.signinPasswordPlaceholder": "Enter your password",
  "cowork.login.signinButton": "Sign in",
  "cowork.login.signupButton": "Create workspace",
  "cowork.login.forgotPassword": "Forgot password?",
  "cowork.login.backToSignin": "Back to sign in",
  "cowork.login.verificationSentTitle": "Check your inbox",
  "cowork.login.verificationSentDescription":
    "We sent a confirmation link to {{email}}. Open it to finish creating your workspace.",
  "cowork.login.verificationSentHint":
    "The link is valid for 24 hours. If it does not arrive, check your spam folder or request a new one.",
  "cowork.login.resendVerification": "Send the link again",
  "cowork.login.verifyTitle": "Confirming your email",
  "cowork.login.verifyDescription": "One moment while we verify your address and open your workspace.",
  "cowork.login.inviteTitle": "You have been invited",
  "cowork.login.inviteInvalidTitle": "This invitation cannot be used",
  "cowork.login.inviteDescription": "{{inviter}} invited you to join {{workspace}} as {{role}}.",
  "cowork.login.inviteSomeone": "A workspace admin",
  "cowork.login.inviteAccept": "Accept invitation",
  "cowork.login.inviteSigninHint": "An account with this email already exists. Sign in to accept the invitation.",
  "cowork.login.inviteSigninAccept": "Sign in and accept",
  "cowork.login.inviteCreateAccount": "Create account and join",
  "cowork.login.resetTitle": "Reset your password",
  "cowork.login.resetDescription": "Enter your email and we will send you a link to choose a new password.",
  "cowork.login.resetSent":
    "If an account exists for {{email}}, a reset link is on its way. The link is valid for 1 hour.",
  "cowork.login.resetSendLink": "Send reset link",
  "cowork.login.resetNewTitle": "Choose a new password",
  "cowork.login.resetNewDescription": "Your previous sessions will be signed out.",
  "cowork.login.newPassword": "New password",
  "cowork.login.resetSave": "Save password and sign in",
  "cowork.login.error.invalidCredentials": "The email or password is incorrect. Please try again.",
  "cowork.login.error.accountExists": "An account with this email already exists. Sign in instead.",
  "cowork.login.error.passwordRequired": "Enter your password.",
  "cowork.login.error.passwordTooShort": "Your password must contain at least 8 characters.",
  "cowork.login.error.passwordTooLong": "Your password must contain no more than 256 characters.",
  "cowork.login.error.passwordInvalid": "Enter a password between 8 and 256 characters.",
  "cowork.login.error.invalidEmail": "Enter a valid email address.",
  "cowork.login.error.invalidFullName": "Enter your full name using 1 to 255 characters.",
  "cowork.login.error.invalidOrganization": "Enter an organization name using 1 to 255 characters.",
  "cowork.login.error.networkError": "Unable to connect. Check your internet connection and try again.",
  "cowork.login.error.serviceUnavailable": "Account access is temporarily unavailable. Please try again later.",
  "cowork.login.error.requestFailed": "We could not complete your request. Please try again.",
  "cowork.login.error.emailNotVerified": "Confirm your email before signing in. We sent you a link when you registered.",
  "cowork.login.error.invalidLink": "This link is invalid or has expired. Request a new one.",
  "cowork.login.error.invitationNotFound": "This invitation link is not valid.",
  "cowork.login.error.invitationGone":
    "This invitation has expired or was withdrawn. Ask your workspace admin to send a new one.",
  "cowork.login.error.invitationWrongAccount": "This invitation was sent to a different email address.",
  "cowork.login.newToSuperCowork": "New to Andmera?",
  "cowork.login.createWorkspaceLink": "Create workspace",
  "cowork.login.registrationInviteOnly": "Workspace creation is currently invite-only. Ask a workspace admin for an invitation.",
  "cowork.login.alreadyRegistered": "Already have an account?",
  "cowork.login.signinLink": "Sign in",
  "cowork.login.button": "Sign in",
  "cowork.login.loading": "Please wait...",
  "cowork.enterprise.nav.adminWorkspaces": "Workspaces",
  "cowork.adminWorkspaces.title": "Workspaces",
  "cowork.adminWorkspaces.description": "Every firm on Andmera with its plan and seats. Changes apply immediately.",
  "cowork.adminWorkspaces.error": "Request failed",
  "cowork.adminWorkspaces.done": "Done",
  "cowork.adminWorkspaces.loading": "Loading workspaces...",
  "cowork.adminWorkspaces.empty": "No workspaces yet",
  "cowork.adminWorkspaces.summary": "/{{slug}} · {{owner}} · Companies: {{companies}} · Seats: {{used}}/{{limit}}",
  "cowork.adminWorkspaces.plan": "Plan",
  "cowork.adminWorkspaces.month": "Month",
  "cowork.adminWorkspaces.usage": "Active companies: {{active}}/{{companies}} · Report runs: {{runs}} · Estimated invoice: €{{invoice}}",
  "cowork.adminWorkspaces.fairUse": "Fair-use level reached: {{companies}}",
  "cowork.adminWorkspaces.total": "Estimated invoices for {{month}}: €{{total}}",
  "cowork.adminWorkspaces.totalDescription": "Platform workspaces pay €30 per active company. Other plans are not invoiced.",
  "cowork.adminWorkspaces.seatLimit": "Seat limit",
  "cowork.adminWorkspaces.save": "Save",
  "cowork.adminWorkspaces.saving": "Saving...",
  "cowork.adminWorkspaces.saved": "{{name}} updated.",
  "cowork.adminWorkspaces.plan.internal": "Internal",
  "cowork.adminWorkspaces.plan.early_access": "Early access",
  "cowork.adminWorkspaces.plan.trial": "Trial",
  "cowork.adminWorkspaces.plan.platform": "Platform",
  "cowork.adminWorkspaces.plan.enterprise": "Enterprise",
  "cowork.manageUsers.title": "Manage users",
  "cowork.manageUsers.description": "Manage accounts across Andmera workspaces.",
  "cowork.manageUsers.add": "Add user",
  "cowork.manageUsers.addDescription": "Send an account setup invitation for a new trial workspace.",
  "cowork.manageUsers.workspaceName": "Workspace name",
  "cowork.manageUsers.invite": "Send invitation",
  "cowork.manageUsers.invited": "Invitation sent. The user can finish creating their account from the email link.",
  "cowork.manageUsers.search": "Search by name or email",
  "cowork.manageUsers.searchButton": "Search",
  "cowork.manageUsers.accountStatus": "Account status",
  "cowork.manageUsers.status.active": "Active",
  "cowork.manageUsers.status.disabled": "Disabled",
  "cowork.manageUsers.status.deleted": "Deleted",
  "cowork.manageUsers.status.pending": "Pending setup",
  "cowork.manageUsers.saved": "User updated.",
  "cowork.manageUsers.deleted": "User deleted and access removed.",
  "cowork.manageUsers.delete": "Delete",
  "cowork.manageUsers.confirmDelete": "Confirm delete",
  "cowork.manageUsers.cancel": "Cancel",
  "cowork.manageUsers.loading": "Loading users...",
  "cowork.manageUsers.empty": "No users found",
  "cowork.manageUsers.error": "Unable to load users",
  "cowork.manageUsers.previous": "Previous",
  "cowork.manageUsers.next": "Next",
  "cowork.onboarding.skip": "Skip setup",
  "cowork.onboarding.skipStep": "Skip this step",
  "cowork.onboarding.progress": "Step {{current}} of {{total}}",
  "cowork.onboarding.continue": "Continue",
  "cowork.onboarding.saving": "Saving...",
  "cowork.onboarding.error": "Something went wrong. Please try again.",
  "cowork.onboarding.workspace.title": "Create your workspace",
  "cowork.onboarding.workspace.description": "Define your workspace name and URL. You can change both of these later in workspace settings",
  "cowork.onboarding.workspace.name": "Workspace name",
  "cowork.onboarding.workspace.url": "Workspace URL",
  "cowork.onboarding.preferences.title": "Set your company preferences",
  "cowork.onboarding.preferences.description": "Choose where your company operates and the language you want the agent to use in its replies.",
  "cowork.onboarding.preferences.country": "Which country does your company operate in?",
  "cowork.onboarding.preferences.chooseCountry": "Choose a country",
  "cowork.onboarding.preferences.otherCountry": "Another country",
  "cowork.onboarding.preferences.countryCode": "Two-letter country code",
  "cowork.onboarding.preferences.countryCodeExample": "For example, JP",
  "cowork.onboarding.preferences.responseLanguage": "Agent response language",
  "cowork.onboarding.preferences.responseLanguageHint": "Choose a language for agent replies, or use your app language.",
  "cowork.onboarding.templates.title": "Generate your first report",
  "cowork.onboarding.templates.description": "Choose a report template to start a new chat with your agent. You can add source files in the chat.",
  "cowork.onboarding.profile.title": "Set up your profile",
  "cowork.onboarding.profile.description": "Your teammates see your name and username across the workspace.",
  "cowork.onboarding.profile.fullName": "Full name",
  "cowork.onboarding.profile.username": "Username",
  "cowork.onboarding.client.title": "Add your first client",
  "cowork.onboarding.client.description": "Search the Estonian business register to fill in the registration code and VAT number, or enter them yourself.",
  "cowork.onboarding.client.search": "Search by company name or registration code",
  "cowork.onboarding.client.name": "Client name",
  "cowork.onboarding.client.registration": "Registration code",
  "cowork.onboarding.client.vat": "VAT number",
  "cowork.onboarding.client.add": "Add client",
  "cowork.onboarding.team.title": "Invite your team",
  "cowork.onboarding.team.description": "Up to {{seats}} people can work in this workspace, you included. Each invitation arrives by email.",
  "cowork.onboarding.team.email": "Teammate's email",
  "cowork.onboarding.team.send": "Send invitations",
  "cowork.onboarding.team.seatLimit": "Your workspace has no free seats left.",
  "cowork.onboarding.report.title": "Run your first report",
  "cowork.onboarding.report.description": "Pick a report, upload the source files, and Andmera prepares it for your review.",
  "cowork.onboarding.report.trialBalance": "Trial balance",
  "cowork.onboarding.report.journal": "Journal",
  "cowork.onboarding.report.accountCard": "Account card",
  "cowork.onboarding.report.start": "Choose a report",
  "cowork.onboarding.report.dashboard": "Go to the dashboard",
  "cowork.onboarding.handle.available": "Available",
  "cowork.onboarding.handle.taken": "Already taken",
  "cowork.onboarding.handle.reserved": "This name is reserved",
  "cowork.onboarding.handle.invalid": "Use lowercase letters, numbers, and hyphens",
  "cowork.onboarding.handle.suggestion": "Use {{value}}",
  "cowork.enterprise.settings.workspaceUrl": "Workspace URL",
  "cowork.enterprise.settings.workspaceUrlDescription": "The address your team uses to open this workspace. Links with the old address stop working.",
  "cowork.enterprise.settings.profile": "Your profile",
  "cowork.enterprise.settings.username": "Username",
  "cowork.enterprise.settings.usernameDescription": "How teammates see you in this workspace. It only has to be unique here.",
  "cowork.login.logout": "Sign out {{email}}",
  "cowork.login.footer": "",
  "cowork.login.metric.files.value": "Files",
  "cowork.login.metric.files.label": "Upload and inspect source documents",
  "cowork.login.metric.workflow.value": "Workflow",
  "cowork.login.metric.workflow.label": "Run governed business workflows",
  "cowork.login.metric.report.value": "Reports",
  "cowork.login.metric.report.label": "Generate business-ready reports and decisions",
  "cowork.login.secure.title": "Secure by design",
  "cowork.login.secure.description":
    "Your sessions, files, generated reports, and approvals are scoped to your workspace.",
  "cowork.login.msalMissing": "Email sign-in is not available right now.",
}
